import './assets/base.css';import './assets/index.css';/* empty css         */
import { jsx as f, jsxs as M, Fragment as it } from "react/jsx-runtime";
import * as h from "react";
import K, { useLayoutEffect as no, useEffect as Ve, useRef as He, lazy as B, Suspense as oo, createContext as fn, useContext as mn, useState as Ie, useMemo as pn, useId as de, forwardRef as Et, Fragment as ro, useReducer as mr, useCallback as pr } from "react";
import * as so from "react-dom";
import { createPortal as io } from "react-dom";
import { DialogPanel as gr, Dialog as hr, DialogBackdrop as br, Description as vr, DialogTitle as yr, Field as at, Listbox as ao, ListboxButton as lo, ListboxOptions as co, ListboxOption as uo, Label as wr, TabGroup as _r, TabPanel as fo, TabList as xr, Tab as Cr, Textarea as Tr, Input as Sr, Switch as Rr } from "@headlessui/react";
import { IconNavigationArrowDown as mo, Text as gn } from "@twinkltech/web-ui";
function kt() {
  return typeof window < "u";
}
function Ne(e) {
  return po(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function oe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ge(e) {
  var t;
  return (t = (po(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function po(e) {
  return kt() ? e instanceof Node || e instanceof oe(e).Node : !1;
}
function z(e) {
  return kt() ? e instanceof Element || e instanceof oe(e).Element : !1;
}
function Y(e) {
  return kt() ? e instanceof HTMLElement || e instanceof oe(e).HTMLElement : !1;
}
function tn(e) {
  return !kt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof oe(e).ShadowRoot;
}
const Er = /* @__PURE__ */ new Set(["inline", "contents"]);
function lt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = se(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !Er.has(r);
}
const kr = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Ir(e) {
  return kr.has(Ne(e));
}
const Nr = [":popover-open", ":modal"];
function It(e) {
  return Nr.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Lr = ["transform", "translate", "scale", "rotate", "perspective"], Or = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Ar = ["paint", "layout", "strict", "content"];
function hn(e) {
  const t = Nt(), n = z(e) ? se(e) : e;
  return Lr.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Or.some((o) => (n.willChange || "").includes(o)) || Ar.some((o) => (n.contain || "").includes(o));
}
function Mr(e) {
  let t = ye(e);
  for (; Y(t) && !Re(t); ) {
    if (hn(t))
      return t;
    if (It(t))
      return null;
    t = ye(t);
  }
  return null;
}
function Nt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Pr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Re(e) {
  return Pr.has(Ne(e));
}
function se(e) {
  return oe(e).getComputedStyle(e);
}
function Lt(e) {
  return z(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ye(e) {
  if (Ne(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    tn(e) && e.host || // Fallback.
    ge(e)
  );
  return tn(t) ? t.host : t;
}
function go(e) {
  const t = ye(e);
  return Re(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Y(t) && lt(t) ? t : go(t);
}
function Se(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = go(e), s = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = oe(r);
  if (s) {
    const a = nn(i);
    return t.concat(i, i.visualViewport || [], lt(r) ? r : [], a && n ? Se(a) : []);
  }
  return t.concat(r, Se(r, [], n));
}
function nn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function he(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function J(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && tn(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function ho() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function bo() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: o
    } = t;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function Br(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : on() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function vo(e) {
  return Dr() ? !1 : !on() && e.width === 0 && e.height === 0 || on() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function yo() {
  return /apple/i.test(navigator.vendor);
}
function on() {
  const e = /android/i;
  return e.test(ho()) || e.test(bo());
}
function Fr() {
  return ho().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Dr() {
  return bo().includes("jsdom/");
}
function tt(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function $r(e) {
  return "nativeEvent" in e;
}
function jr(e) {
  return e.matches("html,body");
}
function ee(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function qt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Ce(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Gr = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function bn(e) {
  return Y(e) && e.matches(Gr);
}
function zt(e) {
  e.preventDefault(), e.stopPropagation();
}
function Wr(e) {
  return e ? e.getAttribute("role") === "combobox" && bn(e) : !1;
}
const Ee = Math.min, re = Math.max, vt = Math.round, ft = Math.floor, pe = (e) => ({
  x: e,
  y: e
}), Vr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Hr = {
  start: "end",
  end: "start"
};
function rn(e, t, n) {
  return re(e, Ee(t, n));
}
function qe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ke(e) {
  return e.split("-")[0];
}
function ze(e) {
  return e.split("-")[1];
}
function wo(e) {
  return e === "x" ? "y" : "x";
}
function vn(e) {
  return e === "y" ? "height" : "width";
}
const qr = /* @__PURE__ */ new Set(["top", "bottom"]);
function ve(e) {
  return qr.has(ke(e)) ? "y" : "x";
}
function yn(e) {
  return wo(ve(e));
}
function zr(e, t, n) {
  n === void 0 && (n = !1);
  const o = ze(e), r = yn(e), s = vn(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = yt(i)), [i, yt(i)];
}
function Ur(e) {
  const t = yt(e);
  return [sn(e), t, sn(t)];
}
function sn(e) {
  return e.replace(/start|end/g, (t) => Hr[t]);
}
const In = ["left", "right"], Nn = ["right", "left"], Kr = ["top", "bottom"], Xr = ["bottom", "top"];
function Yr(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Nn : In : t ? In : Nn;
    case "left":
    case "right":
      return t ? Kr : Xr;
    default:
      return [];
  }
}
function Zr(e, t, n, o) {
  const r = ze(e);
  let s = Yr(ke(e), n === "start", o);
  return r && (s = s.map((i) => i + "-" + r), t && (s = s.concat(s.map(sn)))), s;
}
function yt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Vr[t]);
}
function Qr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function _o(e) {
  return typeof e != "number" ? Qr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function wt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.3.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Jr = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], _t = /* @__PURE__ */ Jr.join(","), xo = typeof Element > "u", We = xo ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, xt = !xo && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, nt = function(t, n) {
  var o;
  n === void 0 && (n = !0);
  var r = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), s = r === "" || r === "true", i = s || n && t && nt(t.parentNode);
  return i;
}, es = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, ts = function(t, n, o) {
  if (nt(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(_t));
  return n && We.call(t, _t) && r.unshift(t), r = r.filter(o), r;
}, an = function(t, n, o) {
  for (var r = [], s = Array.from(t); s.length; ) {
    var i = s.shift();
    if (!nt(i, !1))
      if (i.tagName === "SLOT") {
        var a = i.assignedElements(), l = a.length ? a : i.children, c = an(l, !0, o);
        o.flatten ? r.push.apply(r, c) : r.push({
          scopeParent: i,
          candidates: c
        });
      } else {
        var d = We.call(i, _t);
        d && o.filter(i) && (n || !t.includes(i)) && r.push(i);
        var m = i.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(i), b = !nt(m, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (m && b) {
          var u = an(m === !0 ? i.children : m.children, !0, o);
          o.flatten ? r.push.apply(r, u) : r.push({
            scopeParent: i,
            candidates: u
          });
        } else
          s.unshift.apply(s, i.children);
      }
  }
  return r;
}, Co = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, To = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || es(t)) && !Co(t) ? 0 : t.tabIndex;
}, ns = function(t, n) {
  var o = To(t);
  return o < 0 && n && !Co(t) ? 0 : o;
}, os = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, So = function(t) {
  return t.tagName === "INPUT";
}, rs = function(t) {
  return So(t) && t.type === "hidden";
}, ss = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, is = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, as = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || xt(t), o = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(t.name));
  else
    try {
      r = o(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var s = is(r, t.form);
  return !s || s === t;
}, ls = function(t) {
  return So(t) && t.type === "radio";
}, cs = function(t) {
  return ls(t) && !as(t);
}, us = function(t) {
  var n, o = t && xt(t), r = (n = o) === null || n === void 0 ? void 0 : n.host, s = !1;
  if (o && o !== t) {
    var i, a, l;
    for (s = !!((i = r) !== null && i !== void 0 && (a = i.ownerDocument) !== null && a !== void 0 && a.contains(r) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !s && r; ) {
      var c, d, m;
      o = xt(r), r = (c = o) === null || c === void 0 ? void 0 : c.host, s = !!((d = r) !== null && d !== void 0 && (m = d.ownerDocument) !== null && m !== void 0 && m.contains(r));
    }
  }
  return s;
}, Ln = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, r = n.height;
  return o === 0 && r === 0;
}, ds = function(t, n) {
  var o = n.displayCheck, r = n.getShadowRoot;
  if (o === "full-native" && "checkVisibility" in t) {
    var s = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !s;
  }
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = We.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if (We.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  o === "full-native" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var l = t; t; ) {
        var c = t.parentElement, d = xt(t);
        if (c && !c.shadowRoot && r(c) === !0)
          return Ln(t);
        t.assignedSlot ? t = t.assignedSlot : !c && d !== t.ownerDocument ? t = d.host : t = c;
      }
      t = l;
    }
    if (us(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return Ln(t);
  return !1;
}, fs = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND")
            return We.call(n, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ms = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  nt(n) || rs(n) || ds(n, t) || // For a details element with a summary, the summary element gets the focus
  ss(n) || fs(n));
}, ln = function(t, n) {
  return !(cs(n) || To(n) < 0 || !ms(t, n));
}, ps = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ro = function(t) {
  var n = [], o = [];
  return t.forEach(function(r, s) {
    var i = !!r.scopeParent, a = i ? r.scopeParent : r, l = ns(a, i), c = i ? Ro(r.candidates) : a;
    l === 0 ? i ? n.push.apply(n, c) : n.push(a) : o.push({
      documentOrder: s,
      tabIndex: l,
      item: r,
      isScope: i,
      content: c
    });
  }), o.sort(os).reduce(function(r, s) {
    return s.isScope ? r.push.apply(r, s.content) : r.push(s.content), r;
  }, []).concat(n);
}, Ot = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = an([t], n.includeContainer, {
    filter: ln.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: ps
  }) : o = ts(t, n.includeContainer, ln.bind(null, n)), Ro(o);
}, gs = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return We.call(t, _t) === !1 ? !1 : ln(n, t);
};
function On(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const s = ve(t), i = yn(t), a = vn(i), l = ke(t), c = s === "y", d = o.x + o.width / 2 - r.width / 2, m = o.y + o.height / 2 - r.height / 2, b = o[a] / 2 - r[a] / 2;
  let u;
  switch (l) {
    case "top":
      u = {
        x: d,
        y: o.y - r.height
      };
      break;
    case "bottom":
      u = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: m
      };
      break;
    case "left":
      u = {
        x: o.x - r.width,
        y: m
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (ze(t)) {
    case "start":
      u[i] -= b * (n && c ? -1 : 1);
      break;
    case "end":
      u[i] += b * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const hs = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = s.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: m
  } = On(c, o, l), b = o, u = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: y,
      fn: w
    } = a[g], {
      x,
      y: _,
      data: T,
      reset: k
    } = await w({
      x: d,
      y: m,
      initialPlacement: o,
      placement: b,
      strategy: r,
      middlewareData: u,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = x ?? d, m = _ ?? m, u = {
      ...u,
      [y]: {
        ...u[y],
        ...T
      }
    }, k && p <= 50 && (p++, typeof k == "object" && (k.placement && (b = k.placement), k.rects && (c = k.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : k.rects), {
      x: d,
      y: m
    } = On(c, b, l)), g = -1);
  }
  return {
    x: d,
    y: m,
    placement: b,
    strategy: r,
    middlewareData: u
  };
};
async function wn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: m = "floating",
    altBoundary: b = !1,
    padding: u = 0
  } = qe(t, e), p = _o(u), y = a[b ? m === "floating" ? "reference" : "floating" : m], w = wt(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(y))) == null || n ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), x = m === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, _ = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), T = await (s.isElement == null ? void 0 : s.isElement(_)) ? await (s.getScale == null ? void 0 : s.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = wt(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: _,
    strategy: l
  }) : x);
  return {
    top: (w.top - k.top + p.top) / T.y,
    bottom: (k.bottom - w.bottom + p.bottom) / T.y,
    left: (w.left - k.left + p.left) / T.x,
    right: (k.right - w.right + p.right) / T.x
  };
}
const bs = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: d = 0
    } = qe(e, t) || {};
    if (c == null)
      return {};
    const m = _o(d), b = {
      x: n,
      y: o
    }, u = yn(r), p = vn(u), g = await i.getDimensions(c), y = u === "y", w = y ? "top" : "left", x = y ? "bottom" : "right", _ = y ? "clientHeight" : "clientWidth", T = s.reference[p] + s.reference[u] - b[u] - s.floating[p], k = b[u] - s.reference[u], P = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let N = P ? P[_] : 0;
    (!N || !await (i.isElement == null ? void 0 : i.isElement(P))) && (N = a.floating[_] || s.floating[p]);
    const F = T / 2 - k / 2, V = N / 2 - g[p] / 2 - 1, $ = Ee(m[w], V), j = Ee(m[x], V), S = $, q = N - g[p] - j, L = N / 2 - g[p] / 2 + F, E = rn(S, L, q), D = !l.arrow && ze(r) != null && L !== E && s.reference[p] / 2 - (L < S ? $ : j) - g[p] / 2 < 0, R = D ? L < S ? L - S : L - q : 0;
    return {
      [u]: b[u] + R,
      data: {
        [u]: E,
        centerOffset: L - E - R,
        ...D && {
          alignmentOffset: R
        }
      },
      reset: D
    };
  }
}), vs = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: m = !0,
        fallbackPlacements: b,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...y
      } = qe(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const w = ke(r), x = ve(a), _ = ke(a) === a, T = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), k = b || (_ || !g ? [yt(a)] : Ur(a)), P = p !== "none";
      !b && P && k.push(...Zr(a, g, p, T));
      const N = [a, ...k], F = await wn(t, y), V = [];
      let $ = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (d && V.push(F[w]), m) {
        const L = zr(r, i, T);
        V.push(F[L[0]], F[L[1]]);
      }
      if ($ = [...$, {
        placement: r,
        overflows: V
      }], !V.every((L) => L <= 0)) {
        var j, S;
        const L = (((j = s.flip) == null ? void 0 : j.index) || 0) + 1, E = N[L];
        if (E && (!(m === "alignment" ? x !== ve(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        $.every((C) => ve(C.placement) === x ? C.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: $
            },
            reset: {
              placement: E
            }
          };
        let D = (S = $.filter((R) => R.overflows[0] <= 0).sort((R, C) => R.overflows[1] - C.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!D)
          switch (u) {
            case "bestFit": {
              var q;
              const R = (q = $.filter((C) => {
                if (P) {
                  const v = ve(C.placement);
                  return v === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  v === "y";
                }
                return !0;
              }).map((C) => [C.placement, C.overflows.filter((v) => v > 0).reduce((v, O) => v + O, 0)]).sort((C, v) => C[1] - v[1])[0]) == null ? void 0 : q[0];
              R && (D = R);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (r !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
}, ys = /* @__PURE__ */ new Set(["left", "top"]);
async function ws(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = ke(n), a = ze(n), l = ve(n) === "y", c = ys.has(i) ? -1 : 1, d = s && l ? -1 : 1, m = qe(t, e);
  let {
    mainAxis: b,
    crossAxis: u,
    alignmentAxis: p
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return a && typeof p == "number" && (u = a === "end" ? p * -1 : p), l ? {
    x: u * d,
    y: b * c
  } : {
    x: b * c,
    y: u * d
  };
}
const _s = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: i,
        middlewareData: a
      } = t, l = await ws(t, e);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, xs = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: a = {
          fn: (y) => {
            let {
              x: w,
              y: x
            } = y;
            return {
              x: w,
              y: x
            };
          }
        },
        ...l
      } = qe(e, t), c = {
        x: n,
        y: o
      }, d = await wn(t, l), m = ve(ke(r)), b = wo(m);
      let u = c[b], p = c[m];
      if (s) {
        const y = b === "y" ? "top" : "left", w = b === "y" ? "bottom" : "right", x = u + d[y], _ = u - d[w];
        u = rn(x, u, _);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", x = p + d[y], _ = p - d[w];
        p = rn(x, p, _);
      }
      const g = a.fn({
        ...t,
        [b]: u,
        [m]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [b]: s,
            [m]: i
          }
        }
      };
    }
  };
}, Cs = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: s,
        platform: i,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = qe(e, t), d = await wn(t, c), m = ke(r), b = ze(r), u = ve(r) === "y", {
        width: p,
        height: g
      } = s.floating;
      let y, w;
      m === "top" || m === "bottom" ? (y = m, w = b === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (w = m, y = b === "end" ? "top" : "bottom");
      const x = g - d.top - d.bottom, _ = p - d.left - d.right, T = Ee(g - d[y], x), k = Ee(p - d[w], _), P = !t.middlewareData.shift;
      let N = T, F = k;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (F = _), (o = t.middlewareData.shift) != null && o.enabled.y && (N = x), P && !b) {
        const $ = re(d.left, 0), j = re(d.right, 0), S = re(d.top, 0), q = re(d.bottom, 0);
        u ? F = p - 2 * ($ !== 0 || j !== 0 ? $ + j : re(d.left, d.right)) : N = g - 2 * (S !== 0 || q !== 0 ? S + q : re(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: F,
        availableHeight: N
      });
      const V = await i.getDimensions(a.floating);
      return p !== V.width || g !== V.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Eo(e) {
  const t = se(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = Y(e), s = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, a = vt(n) !== s || vt(o) !== i;
  return a && (n = s, o = i), {
    width: n,
    height: o,
    $: a
  };
}
function _n(e) {
  return z(e) ? e : e.contextElement;
}
function je(e) {
  const t = _n(e);
  if (!Y(t))
    return pe(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = Eo(t);
  let i = (s ? vt(n.width) : n.width) / o, a = (s ? vt(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const Ts = /* @__PURE__ */ pe(0);
function ko(e) {
  const t = oe(e);
  return !Nt() || !t.visualViewport ? Ts : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ss(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== oe(e) ? !1 : t;
}
function Ae(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = _n(e);
  let i = pe(1);
  t && (o ? z(o) && (i = je(o)) : i = je(e));
  const a = Ss(s, n, o) ? ko(s) : pe(0);
  let l = (r.left + a.x) / i.x, c = (r.top + a.y) / i.y, d = r.width / i.x, m = r.height / i.y;
  if (s) {
    const b = oe(s), u = o && z(o) ? oe(o) : o;
    let p = b, g = nn(p);
    for (; g && o && u !== p; ) {
      const y = je(g), w = g.getBoundingClientRect(), x = se(g), _ = w.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, T = w.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, d *= y.x, m *= y.y, l += _, c += T, p = oe(g), g = nn(p);
    }
  }
  return wt({
    width: d,
    height: m,
    x: l,
    y: c
  });
}
function At(e, t) {
  const n = Lt(e).scrollLeft;
  return t ? t.left + n : Ae(ge(e)).left + n;
}
function Io(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - At(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function Rs(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const s = r === "fixed", i = ge(o), a = t ? It(t.floating) : !1;
  if (o === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = pe(1);
  const d = pe(0), m = Y(o);
  if ((m || !m && !s) && ((Ne(o) !== "body" || lt(i)) && (l = Lt(o)), Y(o))) {
    const u = Ae(o);
    c = je(o), d.x = u.x + o.clientLeft, d.y = u.y + o.clientTop;
  }
  const b = i && !m && !s ? Io(i, l) : pe(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x + b.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y + b.y
  };
}
function Es(e) {
  return Array.from(e.getClientRects());
}
function ks(e) {
  const t = ge(e), n = Lt(e), o = e.ownerDocument.body, r = re(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), s = re(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + At(e);
  const a = -n.scrollTop;
  return se(o).direction === "rtl" && (i += re(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const An = 25;
function Is(e, t) {
  const n = oe(e), o = ge(e), r = n.visualViewport;
  let s = o.clientWidth, i = o.clientHeight, a = 0, l = 0;
  if (r) {
    s = r.width, i = r.height;
    const d = Nt();
    (!d || d && t === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  const c = At(o);
  if (c <= 0) {
    const d = o.ownerDocument, m = d.body, b = getComputedStyle(m), u = d.compatMode === "CSS1Compat" && parseFloat(b.marginLeft) + parseFloat(b.marginRight) || 0, p = Math.abs(o.clientWidth - m.clientWidth - u);
    p <= An && (s -= p);
  } else c <= An && (s += c);
  return {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
const Ns = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ls(e, t) {
  const n = Ae(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, s = Y(e) ? je(e) : pe(1), i = e.clientWidth * s.x, a = e.clientHeight * s.y, l = r * s.x, c = o * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function Mn(e, t, n) {
  let o;
  if (t === "viewport")
    o = Is(e, n);
  else if (t === "document")
    o = ks(ge(e));
  else if (z(t))
    o = Ls(t, n);
  else {
    const r = ko(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return wt(o);
}
function No(e, t) {
  const n = ye(e);
  return n === t || !z(n) || Re(n) ? !1 : se(n).position === "fixed" || No(n, t);
}
function Os(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Se(e, [], !1).filter((a) => z(a) && Ne(a) !== "body"), r = null;
  const s = se(e).position === "fixed";
  let i = s ? ye(e) : e;
  for (; z(i) && !Re(i); ) {
    const a = se(i), l = hn(i);
    !l && a.position === "fixed" && (r = null), (s ? !l && !r : !l && a.position === "static" && !!r && Ns.has(r.position) || lt(i) && !l && No(e, i)) ? o = o.filter((d) => d !== i) : r = a, i = ye(i);
  }
  return t.set(e, o), o;
}
function As(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? It(t) ? [] : Os(t, this._c) : [].concat(n), o], a = i[0], l = i.reduce((c, d) => {
    const m = Mn(t, d, r);
    return c.top = re(m.top, c.top), c.right = Ee(m.right, c.right), c.bottom = Ee(m.bottom, c.bottom), c.left = re(m.left, c.left), c;
  }, Mn(t, a, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Ms(e) {
  const {
    width: t,
    height: n
  } = Eo(e);
  return {
    width: t,
    height: n
  };
}
function Ps(e, t, n) {
  const o = Y(t), r = ge(t), s = n === "fixed", i = Ae(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = pe(0);
  function c() {
    l.x = At(r);
  }
  if (o || !o && !s)
    if ((Ne(t) !== "body" || lt(r)) && (a = Lt(t)), o) {
      const u = Ae(t, !0, s, t);
      l.x = u.x + t.clientLeft, l.y = u.y + t.clientTop;
    } else r && c();
  s && !o && r && c();
  const d = r && !o && !s ? Io(r, a) : pe(0), m = i.left + a.scrollLeft - l.x - d.x, b = i.top + a.scrollTop - l.y - d.y;
  return {
    x: m,
    y: b,
    width: i.width,
    height: i.height
  };
}
function Ut(e) {
  return se(e).position === "static";
}
function Pn(e, t) {
  if (!Y(e) || se(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ge(e) === n && (n = n.ownerDocument.body), n;
}
function Lo(e, t) {
  const n = oe(e);
  if (It(e))
    return n;
  if (!Y(e)) {
    let r = ye(e);
    for (; r && !Re(r); ) {
      if (z(r) && !Ut(r))
        return r;
      r = ye(r);
    }
    return n;
  }
  let o = Pn(e, t);
  for (; o && Ir(o) && Ut(o); )
    o = Pn(o, t);
  return o && Re(o) && Ut(o) && !hn(o) ? n : o || Mr(e) || n;
}
const Bs = async function(e) {
  const t = this.getOffsetParent || Lo, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Ps(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Fs(e) {
  return se(e).direction === "rtl";
}
const Ds = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Rs,
  getDocumentElement: ge,
  getClippingRect: As,
  getOffsetParent: Lo,
  getElementRects: Bs,
  getClientRects: Es,
  getDimensions: Ms,
  getScale: je,
  isElement: z,
  isRTL: Fs
};
function Oo(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function $s(e, t) {
  let n = null, o;
  const r = ge(e);
  function s() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const c = e.getBoundingClientRect(), {
      left: d,
      top: m,
      width: b,
      height: u
    } = c;
    if (a || t(), !b || !u)
      return;
    const p = ft(m), g = ft(r.clientWidth - (d + b)), y = ft(r.clientHeight - (m + u)), w = ft(d), _ = {
      rootMargin: -p + "px " + -g + "px " + -y + "px " + -w + "px",
      threshold: re(0, Ee(1, l)) || 1
    };
    let T = !0;
    function k(P) {
      const N = P[0].intersectionRatio;
      if (N !== l) {
        if (!T)
          return i();
        N ? i(!1, N) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      N === 1 && !Oo(c, e.getBoundingClientRect()) && i(), T = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ..._,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, _);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function Ao(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = _n(e), d = r || s ? [...c ? Se(c) : [], ...Se(t)] : [];
  d.forEach((w) => {
    r && w.addEventListener("scroll", n, {
      passive: !0
    }), s && w.addEventListener("resize", n);
  });
  const m = c && a ? $s(c, n) : null;
  let b = -1, u = null;
  i && (u = new ResizeObserver((w) => {
    let [x] = w;
    x && x.target === c && u && (u.unobserve(t), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var _;
      (_ = u) == null || _.observe(t);
    })), n();
  }), c && !l && u.observe(c), u.observe(t));
  let p, g = l ? Ae(e) : null;
  l && y();
  function y() {
    const w = Ae(e);
    g && !Oo(g, w) && n(), g = w, p = requestAnimationFrame(y);
  }
  return n(), () => {
    var w;
    d.forEach((x) => {
      r && x.removeEventListener("scroll", n), s && x.removeEventListener("resize", n);
    }), m == null || m(), (w = u) == null || w.disconnect(), u = null, l && cancelAnimationFrame(p);
  };
}
const js = _s, Gs = xs, Ws = vs, Vs = Cs, Bn = bs, Hs = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Ds,
    ...n
  }, s = {
    ...r.platform,
    _c: o
  };
  return hs(e, t, {
    ...r,
    platform: s
  });
};
var qs = typeof document < "u", zs = function() {
}, ht = qs ? no : zs;
function Ct(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ct(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !Ct(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Mo(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Fn(e, t) {
  const n = Mo(e);
  return Math.round(t * n) / n;
}
function Kt(e) {
  const t = h.useRef(e);
  return ht(() => {
    t.current = e;
  }), t;
}
function Us(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [d, m] = h.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [b, u] = h.useState(o);
  Ct(b, o) || u(o);
  const [p, g] = h.useState(null), [y, w] = h.useState(null), x = h.useCallback((C) => {
    C !== P.current && (P.current = C, g(C));
  }, []), _ = h.useCallback((C) => {
    C !== N.current && (N.current = C, w(C));
  }, []), T = s || p, k = i || y, P = h.useRef(null), N = h.useRef(null), F = h.useRef(d), V = l != null, $ = Kt(l), j = Kt(r), S = Kt(c), q = h.useCallback(() => {
    if (!P.current || !N.current)
      return;
    const C = {
      placement: t,
      strategy: n,
      middleware: b
    };
    j.current && (C.platform = j.current), Hs(P.current, N.current, C).then((v) => {
      const O = {
        ...v,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: S.current !== !1
      };
      L.current && !Ct(F.current, O) && (F.current = O, so.flushSync(() => {
        m(O);
      }));
    });
  }, [b, t, n, j, S]);
  ht(() => {
    c === !1 && F.current.isPositioned && (F.current.isPositioned = !1, m((C) => ({
      ...C,
      isPositioned: !1
    })));
  }, [c]);
  const L = h.useRef(!1);
  ht(() => (L.current = !0, () => {
    L.current = !1;
  }), []), ht(() => {
    if (T && (P.current = T), k && (N.current = k), T && k) {
      if ($.current)
        return $.current(T, k, q);
      q();
    }
  }, [T, k, q, $, V]);
  const E = h.useMemo(() => ({
    reference: P,
    floating: N,
    setReference: x,
    setFloating: _
  }), [x, _]), D = h.useMemo(() => ({
    reference: T,
    floating: k
  }), [T, k]), R = h.useMemo(() => {
    const C = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return C;
    const v = Fn(D.floating, d.x), O = Fn(D.floating, d.y);
    return a ? {
      ...C,
      transform: "translate(" + v + "px, " + O + "px)",
      ...Mo(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: v,
      top: O
    };
  }, [n, a, D.floating, d.x, d.y]);
  return h.useMemo(() => ({
    ...d,
    update: q,
    refs: E,
    elements: D,
    floatingStyles: R
  }), [d, q, E, D, R]);
}
const Ks = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Bn({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Bn({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Po = (e, t) => ({
  ...js(e),
  options: [e, t]
}), Xs = (e, t) => ({
  ...Gs(e),
  options: [e, t]
}), Bo = (e, t) => ({
  ...Ws(e),
  options: [e, t]
}), Ys = (e, t) => ({
  ...Vs(e),
  options: [e, t]
}), Zs = (e, t) => ({
  ...Ks(e),
  options: [e, t]
}), Fo = {
  ...h
}, Qs = Fo.useInsertionEffect, Js = Qs || ((e) => e());
function ce(e) {
  const t = h.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Js(() => {
    t.current = e;
  }), h.useCallback(function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
var ne = typeof document < "u" ? no : Ve;
function ot() {
  return ot = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ot.apply(this, arguments);
}
let Dn = !1, ei = 0;
const $n = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ei++
);
function ti() {
  const [e, t] = h.useState(() => Dn ? $n() : void 0);
  return ne(() => {
    e == null && t($n());
  }, []), h.useEffect(() => {
    Dn = !0;
  }, []), e;
}
const ni = Fo.useId, Ue = ni || ti;
let rt;
process.env.NODE_ENV !== "production" && (rt = /* @__PURE__ */ new Set());
function oi() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = rt) != null && e.has(r))) {
    var s;
    (s = rt) == null || s.add(r), console.warn(r);
  }
}
function ri() {
  for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = rt) != null && e.has(r))) {
    var s;
    (s = rt) == null || s.add(r), console.error(r);
  }
}
const Do = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    context: {
      placement: o,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: s,
        shift: i
      }
    },
    width: a = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: d = 0,
    staticOffset: m,
    stroke: b,
    d: u,
    style: {
      transform: p,
      ...g
    } = {},
    ...y
  } = t;
  process.env.NODE_ENV !== "production" && (n || oi("The `ref` prop is required for `FloatingArrow`."));
  const w = Ue(), [x, _] = h.useState(!1);
  if (ne(() => {
    if (!r) return;
    se(r).direction === "rtl" && _(!0);
  }, [r]), !r)
    return null;
  const [T, k] = o.split("-"), P = T === "top" || T === "bottom";
  let N = m;
  (P && i != null && i.x || !P && i != null && i.y) && (N = null);
  const F = d * 2, V = F / 2, $ = a / 2 * (c / -8 + 1), j = l / 2 * c / 4, S = !!u, q = N && k === "end" ? "bottom" : "top";
  let L = N && k === "end" ? "right" : "left";
  N && x && (L = k === "end" ? "left" : "right");
  const E = (s == null ? void 0 : s.x) != null ? N || s.x : "", D = (s == null ? void 0 : s.y) != null ? N || s.y : "", R = u || "M0,0" + (" H" + a) + (" L" + (a - $) + "," + (l - j)) + (" Q" + a / 2 + "," + l + " " + $ + "," + (l - j)) + " Z", C = {
    top: S ? "rotate(180deg)" : "",
    left: S ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: S ? "" : "rotate(180deg)",
    right: S ? "rotate(-90deg)" : "rotate(90deg)"
  }[T];
  return /* @__PURE__ */ h.createElement("svg", ot({}, y, {
    "aria-hidden": !0,
    ref: n,
    width: S ? a : a + F,
    height: a,
    viewBox: "0 0 " + a + " " + (l > a ? l : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [L]: E,
      [q]: D,
      [T]: P || S ? "100%" : "calc(100% - " + F / 2 + "px)",
      transform: [C, p].filter((v) => !!v).join(" "),
      ...g
    }
  }), F > 0 && /* @__PURE__ */ h.createElement("path", {
    clipPath: "url(#" + w + ")",
    fill: "none",
    stroke: b,
    strokeWidth: F + (u ? 0 : 1),
    d: R
  }), /* @__PURE__ */ h.createElement("path", {
    stroke: F && !u ? y.fill : "none",
    d: R
  }), /* @__PURE__ */ h.createElement("clipPath", {
    id: w
  }, /* @__PURE__ */ h.createElement("rect", {
    x: -V,
    y: V * (S ? -1 : 1),
    width: a + F,
    height: a
  })));
});
function si() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var o;
      (o = e.get(t)) == null || o.forEach((r) => r(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var o;
      e.set(t, ((o = e.get(t)) == null ? void 0 : o.filter((r) => r !== n)) || []);
    }
  };
}
const ii = /* @__PURE__ */ h.createContext(null), ai = /* @__PURE__ */ h.createContext(null), xn = () => {
  var e;
  return ((e = h.useContext(ii)) == null ? void 0 : e.id) || null;
}, Mt = () => h.useContext(ai);
function Me(e) {
  return "data-floating-ui-" + e;
}
function Ge(e) {
  const t = He(e);
  return ne(() => {
    t.current = e;
  }), t;
}
const jn = /* @__PURE__ */ Me("safe-polygon");
function Xt(e, t, n) {
  return n && !tt(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function li(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    events: s,
    elements: i
  } = e, {
    enabled: a = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: d = !1,
    restMs: m = 0,
    move: b = !0
  } = t, u = Mt(), p = xn(), g = Ge(c), y = Ge(l), w = Ge(n), x = h.useRef(), _ = h.useRef(-1), T = h.useRef(), k = h.useRef(-1), P = h.useRef(!0), N = h.useRef(!1), F = h.useRef(() => {
  }), V = h.useRef(!1), $ = h.useCallback(() => {
    var R;
    const C = (R = r.current.openEvent) == null ? void 0 : R.type;
    return (C == null ? void 0 : C.includes("mouse")) && C !== "mousedown";
  }, [r]);
  h.useEffect(() => {
    if (!a) return;
    function R(C) {
      let {
        open: v
      } = C;
      v || (clearTimeout(_.current), clearTimeout(k.current), P.current = !0, V.current = !1);
    }
    return s.on("openchange", R), () => {
      s.off("openchange", R);
    };
  }, [a, s]), h.useEffect(() => {
    if (!a || !g.current || !n) return;
    function R(v) {
      $() && o(!1, v, "hover");
    }
    const C = ee(i.floating).documentElement;
    return C.addEventListener("mouseleave", R), () => {
      C.removeEventListener("mouseleave", R);
    };
  }, [i.floating, n, o, a, g, $]);
  const j = h.useCallback(function(R, C, v) {
    C === void 0 && (C = !0), v === void 0 && (v = "hover");
    const O = Xt(y.current, "close", x.current);
    O && !T.current ? (clearTimeout(_.current), _.current = window.setTimeout(() => o(!1, R, v), O)) : C && (clearTimeout(_.current), o(!1, R, v));
  }, [y, o]), S = ce(() => {
    F.current(), T.current = void 0;
  }), q = ce(() => {
    if (N.current) {
      const R = ee(i.floating).body;
      R.style.pointerEvents = "", R.removeAttribute(jn), N.current = !1;
    }
  }), L = ce(() => r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1);
  h.useEffect(() => {
    if (!a) return;
    function R(A) {
      if (clearTimeout(_.current), P.current = !1, d && !tt(x.current) || m > 0 && !Xt(y.current, "open"))
        return;
      const X = Xt(y.current, "open", x.current);
      X ? _.current = window.setTimeout(() => {
        w.current || o(!0, A, "hover");
      }, X) : n || o(!0, A, "hover");
    }
    function C(A) {
      if (L()) return;
      F.current();
      const X = ee(i.floating);
      if (clearTimeout(k.current), V.current = !1, g.current && r.current.floatingContext) {
        n || clearTimeout(_.current), T.current = g.current({
          ...r.current.floatingContext,
          tree: u,
          x: A.clientX,
          y: A.clientY,
          onClose() {
            q(), S(), L() || j(A, !0, "safe-polygon");
          }
        });
        const G = T.current;
        X.addEventListener("mousemove", G), F.current = () => {
          X.removeEventListener("mousemove", G);
        };
        return;
      }
      (x.current === "touch" ? !J(i.floating, A.relatedTarget) : !0) && j(A);
    }
    function v(A) {
      L() || r.current.floatingContext && (g.current == null || g.current({
        ...r.current.floatingContext,
        tree: u,
        x: A.clientX,
        y: A.clientY,
        onClose() {
          q(), S(), L() || j(A);
        }
      })(A));
    }
    if (z(i.domReference)) {
      var O;
      const A = i.domReference;
      return n && A.addEventListener("mouseleave", v), (O = i.floating) == null || O.addEventListener("mouseleave", v), b && A.addEventListener("mousemove", R, {
        once: !0
      }), A.addEventListener("mouseenter", R), A.addEventListener("mouseleave", C), () => {
        var X;
        n && A.removeEventListener("mouseleave", v), (X = i.floating) == null || X.removeEventListener("mouseleave", v), b && A.removeEventListener("mousemove", R), A.removeEventListener("mouseenter", R), A.removeEventListener("mouseleave", C);
      };
    }
  }, [i, a, e, d, m, b, j, S, q, o, n, w, u, y, g, r, L]), ne(() => {
    var R;
    if (a && n && (R = g.current) != null && R.__options.blockPointerEvents && $()) {
      N.current = !0;
      const v = i.floating;
      if (z(i.domReference) && v) {
        var C;
        const O = ee(i.floating).body;
        O.setAttribute(jn, "");
        const A = i.domReference, X = u == null || (C = u.nodesRef.current.find((_e) => _e.id === p)) == null || (C = C.context) == null ? void 0 : C.elements.floating;
        return X && (X.style.pointerEvents = ""), O.style.pointerEvents = "none", A.style.pointerEvents = "auto", v.style.pointerEvents = "auto", () => {
          O.style.pointerEvents = "", A.style.pointerEvents = "", v.style.pointerEvents = "";
        };
      }
    }
  }, [a, n, p, i, u, g, $]), ne(() => {
    n || (x.current = void 0, V.current = !1, S(), q());
  }, [n, S, q]), h.useEffect(() => () => {
    S(), clearTimeout(_.current), clearTimeout(k.current), q();
  }, [a, i.domReference, S, q]);
  const E = h.useMemo(() => {
    function R(C) {
      x.current = C.pointerType;
    }
    return {
      onPointerDown: R,
      onPointerEnter: R,
      onMouseMove(C) {
        const {
          nativeEvent: v
        } = C;
        function O() {
          !P.current && !w.current && o(!0, v, "hover");
        }
        d && !tt(x.current) || n || m === 0 || V.current && C.movementX ** 2 + C.movementY ** 2 < 2 || (clearTimeout(k.current), x.current === "touch" ? O() : (V.current = !0, k.current = window.setTimeout(O, m)));
      }
    };
  }, [d, o, n, w, m]), D = h.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(_.current);
    },
    onMouseLeave(R) {
      L() || j(R.nativeEvent, !1);
    }
  }), [j, L]);
  return h.useMemo(() => a ? {
    reference: E,
    floating: D
  } : {}, [a, E, D]);
}
let Gn = 0;
function Fe(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = t;
  o && cancelAnimationFrame(Gn);
  const s = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  r ? s() : Gn = requestAnimationFrame(s);
}
function ci(e, t) {
  var n;
  let o = [], r = (n = e.find((s) => s.id === t)) == null ? void 0 : n.parentId;
  for (; r; ) {
    const s = e.find((i) => i.id === r);
    r = s == null ? void 0 : s.parentId, s && (o = o.concat(s));
  }
  return o;
}
function Je(e, t) {
  let n = e.filter((r) => {
    var s;
    return r.parentId === t && ((s = r.context) == null ? void 0 : s.open);
  }), o = n;
  for (; o.length; )
    o = e.filter((r) => {
      var s;
      return (s = o) == null ? void 0 : s.some((i) => {
        var a;
        return r.parentId === i.id && ((a = r.context) == null ? void 0 : a.open);
      });
    }), n = n.concat(o);
  return n;
}
let De = /* @__PURE__ */ new WeakMap(), mt = /* @__PURE__ */ new WeakSet(), pt = {}, Yt = 0;
const ui = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, $o = (e) => e && (e.host || $o(e.parentNode)), di = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const o = $o(n);
  return e.contains(o) ? o : null;
}).filter((n) => n != null);
function fi(e, t, n, o) {
  const r = "data-floating-ui-inert", s = o ? "inert" : n ? "aria-hidden" : null, i = di(t, e), a = /* @__PURE__ */ new Set(), l = new Set(i), c = [];
  pt[r] || (pt[r] = /* @__PURE__ */ new WeakMap());
  const d = pt[r];
  i.forEach(m), b(t), a.clear();
  function m(u) {
    !u || a.has(u) || (a.add(u), u.parentNode && m(u.parentNode));
  }
  function b(u) {
    !u || l.has(u) || [].forEach.call(u.children, (p) => {
      if (Ne(p) !== "script")
        if (a.has(p))
          b(p);
        else {
          const g = s ? p.getAttribute(s) : null, y = g !== null && g !== "false", w = (De.get(p) || 0) + 1, x = (d.get(p) || 0) + 1;
          De.set(p, w), d.set(p, x), c.push(p), w === 1 && y && mt.add(p), x === 1 && p.setAttribute(r, ""), !y && s && p.setAttribute(s, "true");
        }
    });
  }
  return Yt++, () => {
    c.forEach((u) => {
      const p = (De.get(u) || 0) - 1, g = (d.get(u) || 0) - 1;
      De.set(u, p), d.set(u, g), p || (!mt.has(u) && s && u.removeAttribute(s), mt.delete(u)), g || u.removeAttribute(r);
    }), Yt--, Yt || (De = /* @__PURE__ */ new WeakMap(), De = /* @__PURE__ */ new WeakMap(), mt = /* @__PURE__ */ new WeakSet(), pt = {});
  };
}
function Wn(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = ee(e[0]).body;
  return fi(e.concat(Array.from(o.querySelectorAll("[aria-live]"))), o, t, n);
}
const st = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function jo(e, t) {
  const n = Ot(e, st());
  t === "prev" && n.reverse();
  const o = n.indexOf(he(ee(e)));
  return n.slice(o + 1)[0];
}
function Go() {
  return jo(document.body, "next");
}
function Wo() {
  return jo(document.body, "prev");
}
function et(e, t) {
  const n = t || e.currentTarget, o = e.relatedTarget;
  return !o || !J(n, o);
}
function mi(e) {
  Ot(e, st()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Vn(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
const Pt = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let pi;
function Hn(e) {
  e.key === "Tab" && (e.target, clearTimeout(pi));
}
const Tt = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const [o, r] = h.useState();
  ne(() => (yo() && r("button"), document.addEventListener("keydown", Hn), () => {
    document.removeEventListener("keydown", Hn);
  }), []);
  const s = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: o,
    "aria-hidden": o ? void 0 : !0,
    [Me("focus-guard")]: "",
    style: Pt
  };
  return /* @__PURE__ */ h.createElement("span", ot({}, t, s));
}), Vo = /* @__PURE__ */ h.createContext(null), qn = /* @__PURE__ */ Me("portal");
function gi(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, o = Ue(), r = Ho(), [s, i] = h.useState(null), a = h.useRef(null);
  return ne(() => () => {
    s == null || s.remove(), queueMicrotask(() => {
      a.current = null;
    });
  }, [s]), ne(() => {
    if (!o || a.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = o, c.setAttribute(qn, ""), l.appendChild(c), a.current = c, i(c);
  }, [t, o]), ne(() => {
    if (n === null || !o || a.current) return;
    let l = n || (r == null ? void 0 : r.portalNode);
    l && !z(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const d = document.createElement("div");
    d.id = o, d.setAttribute(qn, ""), l = c || l, l.appendChild(d), a.current = d, i(d);
  }, [t, n, o, r]), s;
}
function Cn(e) {
  const {
    children: t,
    id: n,
    root: o,
    preserveTabOrder: r = !0
  } = e, s = gi({
    id: n,
    root: o
  }), [i, a] = h.useState(null), l = h.useRef(null), c = h.useRef(null), d = h.useRef(null), m = h.useRef(null), b = i == null ? void 0 : i.modal, u = i == null ? void 0 : i.open, p = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!i && // Guards are only for non-modal focus management.
    !i.modal && // Don't render if unmount is transitioning.
    i.open && r && !!(o || s)
  );
  return h.useEffect(() => {
    if (!s || !r || b)
      return;
    function g(y) {
      s && et(y) && (y.type === "focusin" ? Vn : mi)(s);
    }
    return s.addEventListener("focusin", g, !0), s.addEventListener("focusout", g, !0), () => {
      s.removeEventListener("focusin", g, !0), s.removeEventListener("focusout", g, !0);
    };
  }, [s, r, b]), h.useEffect(() => {
    s && (u || Vn(s));
  }, [u, s]), /* @__PURE__ */ h.createElement(Vo.Provider, {
    value: h.useMemo(() => ({
      preserveTabOrder: r,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: d,
      afterInsideRef: m,
      portalNode: s,
      setFocusManagerState: a
    }), [r, s])
  }, p && s && /* @__PURE__ */ h.createElement(Tt, {
    "data-type": "outside",
    ref: l,
    onFocus: (g) => {
      if (et(g, s)) {
        var y;
        (y = d.current) == null || y.focus();
      } else {
        const w = Wo() || (i == null ? void 0 : i.refs.domReference.current);
        w == null || w.focus();
      }
    }
  }), p && s && /* @__PURE__ */ h.createElement("span", {
    "aria-owns": s.id,
    style: Pt
  }), s && /* @__PURE__ */ so.createPortal(t, s), p && s && /* @__PURE__ */ h.createElement(Tt, {
    "data-type": "outside",
    ref: c,
    onFocus: (g) => {
      if (et(g, s)) {
        var y;
        (y = m.current) == null || y.focus();
      } else {
        const w = Go() || (i == null ? void 0 : i.refs.domReference.current);
        w == null || w.focus(), i != null && i.closeOnFocusOut && (i == null || i.onOpenChange(!1, g.nativeEvent, "focus-out"));
      }
    }
  }));
}
const Ho = () => h.useContext(Vo), cn = "data-floating-ui-focusable";
function hi(e) {
  return e ? e.hasAttribute(cn) ? e : e.querySelector("[" + cn + "]") || e : null;
}
const zn = 20;
let Oe = [];
function Zt(e) {
  Oe = Oe.filter((n) => n.isConnected);
  let t = e;
  if (!(!t || Ne(t) === "body")) {
    if (!gs(t, st())) {
      const n = Ot(t, st())[0];
      n && (t = n);
    }
    Oe.push(t), Oe.length > zn && (Oe = Oe.slice(-zn));
  }
}
function Un() {
  return Oe.slice().reverse().find((e) => e.isConnected);
}
const bi = /* @__PURE__ */ h.forwardRef(function(t, n) {
  return /* @__PURE__ */ h.createElement("button", ot({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: Pt
  }));
});
function qo(e) {
  const {
    context: t,
    children: n,
    disabled: o = !1,
    order: r = ["content"],
    guards: s = !0,
    initialFocus: i = 0,
    returnFocus: a = !0,
    restoreFocus: l = !1,
    modal: c = !0,
    visuallyHiddenDismiss: d = !1,
    closeOnFocusOut: m = !0
  } = e, {
    open: b,
    refs: u,
    nodeId: p,
    onOpenChange: g,
    events: y,
    dataRef: w,
    floatingId: x,
    elements: {
      domReference: _,
      floating: T
    }
  } = t, k = typeof i == "number" && i < 0, P = Wr(_) && k, N = ui() ? s : !0, F = Ge(r), V = Ge(i), $ = Ge(a), j = Mt(), S = Ho(), q = h.useRef(null), L = h.useRef(null), E = h.useRef(!1), D = h.useRef(!1), R = h.useRef(-1), C = S != null, v = hi(T), O = ce(function(G) {
    return G === void 0 && (G = v), G ? Ot(G, st()) : [];
  }), A = ce((G) => {
    const H = O(G);
    return F.current.map((I) => _ && I === "reference" ? _ : v && I === "floating" ? v : H).filter(Boolean).flat();
  });
  h.useEffect(() => {
    if (o || !c) return;
    function G(I) {
      if (I.key === "Tab") {
        J(v, he(ee(v))) && O().length === 0 && !P && zt(I);
        const W = A(), U = Ce(I);
        F.current[0] === "reference" && U === _ && (zt(I), I.shiftKey ? Fe(W[W.length - 1]) : Fe(W[1])), F.current[1] === "floating" && U === v && I.shiftKey && (zt(I), Fe(W[0]));
      }
    }
    const H = ee(v);
    return H.addEventListener("keydown", G), () => {
      H.removeEventListener("keydown", G);
    };
  }, [o, _, v, c, F, P, O, A]), h.useEffect(() => {
    if (o || !T) return;
    function G(H) {
      const I = Ce(H), U = O().indexOf(I);
      U !== -1 && (R.current = U);
    }
    return T.addEventListener("focusin", G), () => {
      T.removeEventListener("focusin", G);
    };
  }, [o, T, O]), h.useEffect(() => {
    if (o || !m) return;
    function G() {
      D.current = !0, setTimeout(() => {
        D.current = !1;
      });
    }
    function H(I) {
      const W = I.relatedTarget;
      queueMicrotask(() => {
        const U = !(J(_, W) || J(T, W) || J(W, T) || J(S == null ? void 0 : S.portalNode, W) || W != null && W.hasAttribute(Me("focus-guard")) || j && (Je(j.nodesRef.current, p).find((Q) => {
          var Z, fe;
          return J((Z = Q.context) == null ? void 0 : Z.elements.floating, W) || J((fe = Q.context) == null ? void 0 : fe.elements.domReference, W);
        }) || ci(j.nodesRef.current, p).find((Q) => {
          var Z, fe;
          return ((Z = Q.context) == null ? void 0 : Z.elements.floating) === W || ((fe = Q.context) == null ? void 0 : fe.elements.domReference) === W;
        })));
        if (l && U && he(ee(v)) === ee(v).body) {
          Y(v) && v.focus();
          const Q = R.current, Z = O(), fe = Z[Q] || Z[Z.length - 1] || v;
          Y(fe) && fe.focus();
        }
        (P || !c) && W && U && !D.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        W !== Un() && (E.current = !0, g(!1, I, "focus-out"));
      });
    }
    if (T && Y(_))
      return _.addEventListener("focusout", H), _.addEventListener("pointerdown", G), T.addEventListener("focusout", H), () => {
        _.removeEventListener("focusout", H), _.removeEventListener("pointerdown", G), T.removeEventListener("focusout", H);
      };
  }, [o, _, T, v, c, p, j, S, g, m, l, O, P]), h.useEffect(() => {
    var G;
    if (o) return;
    const H = Array.from((S == null || (G = S.portalNode) == null ? void 0 : G.querySelectorAll("[" + Me("portal") + "]")) || []);
    if (T) {
      const I = [T, ...H, q.current, L.current, F.current.includes("reference") || P ? _ : null].filter((U) => U != null), W = c || P ? Wn(I, N, !N) : Wn(I);
      return () => {
        W();
      };
    }
  }, [o, _, T, c, F, S, P, N]), ne(() => {
    if (o || !Y(v)) return;
    const G = ee(v), H = he(G);
    queueMicrotask(() => {
      const I = A(v), W = V.current, U = (typeof W == "number" ? I[W] : W.current) || v, Q = J(v, H);
      !k && !Q && b && Fe(U, {
        preventScroll: U === v
      });
    });
  }, [o, b, v, k, A, V]), ne(() => {
    if (o || !v) return;
    let G = !1;
    const H = ee(v), I = he(H);
    let U = w.current.openEvent;
    Zt(I);
    function Q(Be) {
      let {
        open: ut,
        reason: dt,
        event: xe,
        nested: Ht
      } = Be;
      ut && (U = xe), dt === "escape-key" && u.domReference.current && Zt(u.domReference.current), dt === "hover" && xe.type === "mouseleave" && (E.current = !0), dt === "outside-press" && (Ht ? (E.current = !1, G = !0) : E.current = !(Br(xe) || vo(xe)));
    }
    y.on("openchange", Q);
    const Z = H.createElement("span");
    Z.setAttribute("tabindex", "-1"), Z.setAttribute("aria-hidden", "true"), Object.assign(Z.style, Pt), C && _ && _.insertAdjacentElement("afterend", Z);
    function fe() {
      return typeof $.current == "boolean" ? Un() || Z : $.current.current || Z;
    }
    return () => {
      y.off("openchange", Q);
      const Be = he(H), ut = J(T, Be) || j && Je(j.nodesRef.current, p).some((Ht) => {
        var kn;
        return J((kn = Ht.context) == null ? void 0 : kn.elements.floating, Be);
      });
      (ut || U && ["click", "mousedown"].includes(U.type)) && u.domReference.current && Zt(u.domReference.current);
      const xe = fe();
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        $.current && !E.current && Y(xe) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(xe !== Be && Be !== H.body) || ut) && xe.focus({
          preventScroll: G
        }), Z.remove();
      });
    };
  }, [o, T, v, $, w, u, y, j, p, C, _]), h.useEffect(() => {
    queueMicrotask(() => {
      E.current = !1;
    });
  }, [o]), ne(() => {
    if (!o && S)
      return S.setFocusManagerState({
        modal: c,
        closeOnFocusOut: m,
        open: b,
        onOpenChange: g,
        refs: u
      }), () => {
        S.setFocusManagerState(null);
      };
  }, [o, S, c, b, g, u, m]), ne(() => {
    if (o || !v || typeof MutationObserver != "function" || k) return;
    const G = () => {
      const I = v.getAttribute("tabindex"), W = O(), U = he(ee(T)), Q = W.indexOf(U);
      Q !== -1 && (R.current = Q), F.current.includes("floating") || U !== u.domReference.current && W.length === 0 ? I !== "0" && v.setAttribute("tabindex", "0") : I !== "-1" && v.setAttribute("tabindex", "-1");
    };
    G();
    const H = new MutationObserver(G);
    return H.observe(v, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      H.disconnect();
    };
  }, [o, T, v, u, F, O, k]);
  function X(G) {
    return o || !d || !c ? null : /* @__PURE__ */ h.createElement(bi, {
      ref: G === "start" ? q : L,
      onClick: (H) => g(!1, H.nativeEvent)
    }, typeof d == "string" ? d : "Dismiss");
  }
  const _e = !o && N && (c ? !P : !0) && (C || c);
  return /* @__PURE__ */ h.createElement(h.Fragment, null, _e && /* @__PURE__ */ h.createElement(Tt, {
    "data-type": "inside",
    ref: S == null ? void 0 : S.beforeInsideRef,
    onFocus: (G) => {
      if (c) {
        const I = A();
        Fe(r[0] === "reference" ? I[0] : I[I.length - 1]);
      } else if (S != null && S.preserveTabOrder && S.portalNode)
        if (E.current = !1, et(G, S.portalNode)) {
          const I = Go() || _;
          I == null || I.focus();
        } else {
          var H;
          (H = S.beforeOutsideRef.current) == null || H.focus();
        }
    }
  }), !P && X("start"), n, X("end"), _e && /* @__PURE__ */ h.createElement(Tt, {
    "data-type": "inside",
    ref: S == null ? void 0 : S.afterInsideRef,
    onFocus: (G) => {
      if (c)
        Fe(A()[0]);
      else if (S != null && S.preserveTabOrder && S.portalNode)
        if (m && (E.current = !0), et(G, S.portalNode)) {
          const I = Wo() || _;
          I == null || I.focus();
        } else {
          var H;
          (H = S.afterOutsideRef.current) == null || H.focus();
        }
    }
  }));
}
function Kn(e) {
  return Y(e.target) && e.target.tagName === "BUTTON";
}
function Xn(e) {
  return bn(e);
}
function vi(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    elements: {
      domReference: s
    }
  } = e, {
    enabled: i = !0,
    event: a = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: d = !0,
    stickIfOpen: m = !0
  } = t, b = h.useRef(), u = h.useRef(!1), p = h.useMemo(() => ({
    onPointerDown(g) {
      b.current = g.pointerType;
    },
    onMouseDown(g) {
      const y = b.current;
      g.button === 0 && a !== "click" && (tt(y, !0) && c || (n && l && (!(r.current.openEvent && m) || r.current.openEvent.type === "mousedown") ? o(!1, g.nativeEvent, "click") : (g.preventDefault(), o(!0, g.nativeEvent, "click"))));
    },
    onClick(g) {
      const y = b.current;
      if (a === "mousedown" && b.current) {
        b.current = void 0;
        return;
      }
      tt(y, !0) && c || (n && l && (!(r.current.openEvent && m) || r.current.openEvent.type === "click") ? o(!1, g.nativeEvent, "click") : o(!0, g.nativeEvent, "click"));
    },
    onKeyDown(g) {
      b.current = void 0, !(g.defaultPrevented || !d || Kn(g)) && (g.key === " " && !Xn(s) && (g.preventDefault(), u.current = !0), g.key === "Enter" && o(!(n && l), g.nativeEvent, "click"));
    },
    onKeyUp(g) {
      g.defaultPrevented || !d || Kn(g) || Xn(s) || g.key === " " && u.current && (u.current = !1, o(!(n && l), g.nativeEvent, "click"));
    }
  }), [r, s, a, c, d, o, n, m, l]);
  return h.useMemo(() => i ? {
    reference: p
  } : {}, [i, p]);
}
const yi = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, wi = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Yn = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function zo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    dataRef: s
  } = e, {
    enabled: i = !0,
    escapeKey: a = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: d = !1,
    referencePressEvent: m = "pointerdown",
    ancestorScroll: b = !1,
    bubbles: u,
    capture: p
  } = t, g = Mt(), y = ce(typeof l == "function" ? l : () => !1), w = typeof l == "function" ? y : l, x = h.useRef(!1), _ = h.useRef(!1), {
    escapeKey: T,
    outsidePress: k
  } = Yn(u), {
    escapeKey: P,
    outsidePress: N
  } = Yn(p), F = h.useRef(!1), V = ce((E) => {
    var D;
    if (!n || !i || !a || E.key !== "Escape" || F.current)
      return;
    const R = (D = s.current.floatingContext) == null ? void 0 : D.nodeId, C = g ? Je(g.nodesRef.current, R) : [];
    if (!T && (E.stopPropagation(), C.length > 0)) {
      let v = !0;
      if (C.forEach((O) => {
        var A;
        if ((A = O.context) != null && A.open && !O.context.dataRef.current.__escapeKeyBubbles) {
          v = !1;
          return;
        }
      }), !v)
        return;
    }
    o(!1, $r(E) ? E.nativeEvent : E, "escape-key");
  }), $ = ce((E) => {
    var D;
    const R = () => {
      var C;
      V(E), (C = Ce(E)) == null || C.removeEventListener("keydown", R);
    };
    (D = Ce(E)) == null || D.addEventListener("keydown", R);
  }), j = ce((E) => {
    var D;
    const R = x.current;
    x.current = !1;
    const C = _.current;
    if (_.current = !1, c === "click" && C || R || typeof w == "function" && !w(E))
      return;
    const v = Ce(E), O = "[" + Me("inert") + "]", A = ee(r.floating).querySelectorAll(O);
    let X = z(v) ? v : null;
    for (; X && !Re(X); ) {
      const I = ye(X);
      if (Re(I) || !z(I))
        break;
      X = I;
    }
    if (A.length && z(v) && !jr(v) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !J(v, r.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(A).every((I) => !J(X, I)))
      return;
    if (Y(v) && L) {
      const I = v.clientWidth > 0 && v.scrollWidth > v.clientWidth, W = v.clientHeight > 0 && v.scrollHeight > v.clientHeight;
      let U = W && E.offsetX > v.clientWidth;
      if (W && se(v).direction === "rtl" && (U = E.offsetX <= v.offsetWidth - v.clientWidth), U || I && E.offsetY > v.clientHeight)
        return;
    }
    const _e = (D = s.current.floatingContext) == null ? void 0 : D.nodeId, G = g && Je(g.nodesRef.current, _e).some((I) => {
      var W;
      return qt(E, (W = I.context) == null ? void 0 : W.elements.floating);
    });
    if (qt(E, r.floating) || qt(E, r.domReference) || G)
      return;
    const H = g ? Je(g.nodesRef.current, _e) : [];
    if (H.length > 0) {
      let I = !0;
      if (H.forEach((W) => {
        var U;
        if ((U = W.context) != null && U.open && !W.context.dataRef.current.__outsidePressBubbles) {
          I = !1;
          return;
        }
      }), !I)
        return;
    }
    o(!1, E, "outside-press");
  }), S = ce((E) => {
    var D;
    const R = () => {
      var C;
      j(E), (C = Ce(E)) == null || C.removeEventListener(c, R);
    };
    (D = Ce(E)) == null || D.addEventListener(c, R);
  });
  h.useEffect(() => {
    if (!n || !i)
      return;
    s.current.__escapeKeyBubbles = T, s.current.__outsidePressBubbles = k;
    let E = -1;
    function D(A) {
      o(!1, A, "ancestor-scroll");
    }
    function R() {
      window.clearTimeout(E), F.current = !0;
    }
    function C() {
      E = window.setTimeout(
        () => {
          F.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Nt() ? 5 : 0
      );
    }
    const v = ee(r.floating);
    a && (v.addEventListener("keydown", P ? $ : V, P), v.addEventListener("compositionstart", R), v.addEventListener("compositionend", C)), w && v.addEventListener(c, N ? S : j, N);
    let O = [];
    return b && (z(r.domReference) && (O = Se(r.domReference)), z(r.floating) && (O = O.concat(Se(r.floating))), !z(r.reference) && r.reference && r.reference.contextElement && (O = O.concat(Se(r.reference.contextElement)))), O = O.filter((A) => {
      var X;
      return A !== ((X = v.defaultView) == null ? void 0 : X.visualViewport);
    }), O.forEach((A) => {
      A.addEventListener("scroll", D, {
        passive: !0
      });
    }), () => {
      a && (v.removeEventListener("keydown", P ? $ : V, P), v.removeEventListener("compositionstart", R), v.removeEventListener("compositionend", C)), w && v.removeEventListener(c, N ? S : j, N), O.forEach((A) => {
        A.removeEventListener("scroll", D);
      }), window.clearTimeout(E);
    };
  }, [s, r, a, w, c, n, o, b, i, T, k, V, P, $, j, N, S]), h.useEffect(() => {
    x.current = !1;
  }, [w, c]);
  const q = h.useMemo(() => ({
    onKeyDown: V,
    [yi[m]]: (E) => {
      d && o(!1, E.nativeEvent, "reference-press");
    }
  }), [V, o, d, m]), L = h.useMemo(() => ({
    onKeyDown: V,
    onMouseDown() {
      _.current = !0;
    },
    onMouseUp() {
      _.current = !0;
    },
    [wi[c]]: () => {
      x.current = !0;
    }
  }), [V, c]);
  return h.useMemo(() => i ? {
    reference: q,
    floating: L
  } : {}, [i, q, L]);
}
function _i(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: o
  } = e, r = Ue(), s = h.useRef({}), [i] = h.useState(() => si()), a = xn() != null;
  if (process.env.NODE_ENV !== "production") {
    const u = o.reference;
    u && !z(u) && ri("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = h.useState(o.reference), d = ce((u, p, g) => {
    s.current.openEvent = u ? p : void 0, i.emit("openchange", {
      open: u,
      event: p,
      reason: g,
      nested: a
    }), n == null || n(u, p, g);
  }), m = h.useMemo(() => ({
    setPositionReference: c
  }), []), b = h.useMemo(() => ({
    reference: l || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [l, o.reference, o.floating]);
  return h.useMemo(() => ({
    dataRef: s,
    open: t,
    onOpenChange: d,
    elements: b,
    events: i,
    floatingId: r,
    refs: m
  }), [t, d, b, i, r, m]);
}
function Uo(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = _i({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), o = e.rootContext || n, r = o.elements, [s, i] = h.useState(null), [a, l] = h.useState(null), d = (r == null ? void 0 : r.domReference) || s, m = h.useRef(null), b = Mt();
  ne(() => {
    d && (m.current = d);
  }, [d]);
  const u = Us({
    ...e,
    elements: {
      ...r,
      ...a && {
        reference: a
      }
    }
  }), p = h.useCallback((_) => {
    const T = z(_) ? {
      getBoundingClientRect: () => _.getBoundingClientRect(),
      contextElement: _
    } : _;
    l(T), u.refs.setReference(T);
  }, [u.refs]), g = h.useCallback((_) => {
    (z(_) || _ === null) && (m.current = _, i(_)), (z(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    _ !== null && !z(_)) && u.refs.setReference(_);
  }, [u.refs]), y = h.useMemo(() => ({
    ...u.refs,
    setReference: g,
    setPositionReference: p,
    domReference: m
  }), [u.refs, g, p]), w = h.useMemo(() => ({
    ...u.elements,
    domReference: d
  }), [u.elements, d]), x = h.useMemo(() => ({
    ...u,
    ...o,
    refs: y,
    elements: w,
    nodeId: t
  }), [u, y, w, t, o]);
  return ne(() => {
    o.dataRef.current.floatingContext = x;
    const _ = b == null ? void 0 : b.nodesRef.current.find((T) => T.id === t);
    _ && (_.context = x);
  }), h.useMemo(() => ({
    ...u,
    context: x,
    refs: y,
    elements: w
  }), [u, y, w, x]);
}
function xi(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: o,
    events: r,
    dataRef: s,
    elements: i
  } = e, {
    enabled: a = !0,
    visibleOnly: l = !0
  } = t, c = h.useRef(!1), d = h.useRef(), m = h.useRef(!0);
  h.useEffect(() => {
    if (!a) return;
    const u = oe(i.domReference);
    function p() {
      !n && Y(i.domReference) && i.domReference === he(ee(i.domReference)) && (c.current = !0);
    }
    function g() {
      m.current = !0;
    }
    return u.addEventListener("blur", p), u.addEventListener("keydown", g, !0), () => {
      u.removeEventListener("blur", p), u.removeEventListener("keydown", g, !0);
    };
  }, [i.domReference, n, a]), h.useEffect(() => {
    if (!a) return;
    function u(p) {
      let {
        reason: g
      } = p;
      (g === "reference-press" || g === "escape-key") && (c.current = !0);
    }
    return r.on("openchange", u), () => {
      r.off("openchange", u);
    };
  }, [r, a]), h.useEffect(() => () => {
    clearTimeout(d.current);
  }, []);
  const b = h.useMemo(() => ({
    onPointerDown(u) {
      vo(u.nativeEvent) || (m.current = !1);
    },
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(u) {
      if (c.current) return;
      const p = Ce(u.nativeEvent);
      if (l && z(p))
        try {
          if (yo() && Fr()) throw Error();
          if (!p.matches(":focus-visible")) return;
        } catch {
          if (!m.current && !bn(p))
            return;
        }
      o(!0, u.nativeEvent, "focus");
    },
    onBlur(u) {
      c.current = !1;
      const p = u.relatedTarget, g = u.nativeEvent, y = z(p) && p.hasAttribute(Me("focus-guard")) && p.getAttribute("data-type") === "outside";
      d.current = window.setTimeout(() => {
        var w;
        const x = he(i.domReference ? i.domReference.ownerDocument : document);
        !p && x === i.domReference || J((w = s.current.floatingContext) == null ? void 0 : w.refs.floating.current, x) || J(i.domReference, x) || y || o(!1, g, "focus");
      });
    }
  }), [s, i.domReference, o, l]);
  return h.useMemo(() => a ? {
    reference: b
  } : {}, [a, b]);
}
const Zn = "active", Qn = "selected";
function Qt(e, t, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item";
  let s = e;
  if (r && e) {
    const {
      [Zn]: i,
      [Qn]: a,
      ...l
    } = e;
    s = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [cn]: ""
    },
    ...s,
    ...t.map((i) => {
      const a = i ? i[n] : null;
      return typeof a == "function" ? e ? a(e) : null : a;
    }).concat(e).reduce((i, a) => (a && Object.entries(a).forEach((l) => {
      let [c, d] = l;
      if (!(r && [Zn, Qn].includes(c)))
        if (c.indexOf("on") === 0) {
          if (o.has(c) || o.set(c, []), typeof d == "function") {
            var m;
            (m = o.get(c)) == null || m.push(d), i[c] = function() {
              for (var b, u = arguments.length, p = new Array(u), g = 0; g < u; g++)
                p[g] = arguments[g];
              return (b = o.get(c)) == null ? void 0 : b.map((y) => y(...p)).find((y) => y !== void 0);
            };
          }
        } else
          i[c] = d;
    }), i), {})
  };
}
function Ko(e) {
  e === void 0 && (e = []);
  const t = e.map((a) => a == null ? void 0 : a.reference), n = e.map((a) => a == null ? void 0 : a.floating), o = e.map((a) => a == null ? void 0 : a.item), r = h.useCallback(
    (a) => Qt(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = h.useCallback(
    (a) => Qt(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = h.useCallback(
    (a) => Qt(a, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return h.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: s,
    getItemProps: i
  }), [r, s, i]);
}
const Ci = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Ti(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: o,
    floatingId: r
  } = e, {
    enabled: s = !0,
    role: i = "dialog"
  } = t, a = (n = Ci.get(i)) != null ? n : i, l = Ue(), d = xn() != null, m = h.useMemo(() => a === "tooltip" || i === "label" ? {
    ["aria-" + (i === "label" ? "labelledby" : "describedby")]: o ? r : void 0
  } : {
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": a === "alertdialog" ? "dialog" : a,
    "aria-controls": o ? r : void 0,
    ...a === "listbox" && {
      role: "combobox"
    },
    ...a === "menu" && {
      id: l
    },
    ...a === "menu" && d && {
      role: "menuitem"
    },
    ...i === "select" && {
      "aria-autocomplete": "none"
    },
    ...i === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [a, r, d, o, l, i]), b = h.useMemo(() => {
    const p = {
      id: r,
      ...a && {
        role: a
      }
    };
    return a === "tooltip" || i === "label" ? p : {
      ...p,
      ...a === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [a, r, l, i]), u = h.useCallback((p) => {
    let {
      active: g,
      selected: y
    } = p;
    const w = {
      role: "option",
      ...g && {
        id: r + "-option"
      }
    };
    switch (i) {
      case "select":
        return {
          ...w,
          "aria-selected": g && y
        };
      case "combobox":
        return {
          ...w,
          ...g && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [r, i]);
  return h.useMemo(() => s ? {
    reference: m,
    floating: b,
    item: u
  } : {}, [s, m, b, u]);
}
const Si = "_icon_u1p3m_3", Ri = "_colorInherit_u1p3m_10", Ei = "_info_u1p3m_14", ki = "_success_u1p3m_18", Ii = "_danger_u1p3m_22", Ni = "_warning_u1p3m_26", Li = "_none_u1p3m_30", Oi = "_sizeSm_u1p3m_34", Ai = "_sizeMd_u1p3m_38", Mi = "_sizeLg_u1p3m_42", Pi = "_sizeInherit_u1p3m_46", ae = {
  icon: Si,
  colorInherit: Ri,
  info: Ei,
  success: ki,
  danger: Ii,
  warning: Ni,
  none: Li,
  sizeSm: Oi,
  sizeMd: Ai,
  sizeLg: Mi,
  sizeInherit: Pi
}, Bi = ({
  "aria-hidden": e = !0,
  children: t,
  className: n,
  color: o = "current",
  height: r = 24,
  icon: s,
  size: i = "medium",
  viewBox: a = "0 -960 960 960",
  width: l = 24,
  xmlns: c = "http://www.w3.org/2000/svg",
  ...d
}) => {
  const m = [n, ae.icon];
  switch (o) {
    case "inherit":
      m.push(ae.colorInherit);
      break;
    case "info":
      m.push(ae.info);
      break;
    case "success":
      m.push(ae.success);
      break;
    case "warning":
      m.push(ae.warning);
      break;
    case "danger":
      m.push(ae.danger);
      break;
    case "none":
      m.push(ae.none);
      break;
  }
  switch (i) {
    case "inherit":
      m.push(ae.sizeInherit);
      break;
    case "small":
      m.push(ae.sizeSm);
      break;
    case "medium":
      m.push(ae.sizeMd);
      break;
    case "large":
      m.push(ae.sizeLg);
      break;
  }
  return K.createElement(
    "svg",
    {
      className: m.filter(Boolean).join(" "),
      focusable: !1,
      height: r,
      "aria-hidden": e,
      role: e ? void 0 : d.role || "img",
      "aria-label": e ? void 0 : d["aria-label"],
      "data-testid": void 0,
      // Add test ID only in test environment
      viewBox: a,
      width: l,
      xmlns: c,
      ...d
    },
    t
  );
}, Fi = "_iconLoader_j2buw_12", Di = {
  iconLoader: Fi
}, Jn = (e) => {
  const t = [Di.iconLoader, e.className].filter(Boolean).join(" ");
  return /* @__PURE__ */ f(
    Bi,
    {
      icon: "loading",
      ...e,
      className: t,
      color: "none",
      children: /* @__PURE__ */ f("path", { d: "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z" })
    }
  );
}, $i = {
  AccountBalance: B(() => import("./AccountBalance-CDk7fnRX.js")),
  AccountCircle: B(() => import("./AccountCircle-CtyMBArH.js")),
  Add: B(() => import("./Add-D0wyEa06.js")),
  ArrowForwardIos: B(
    () => import("./ArrowForwardIos-D3BhZi5e.js")
  ),
  AutoStories: B(() => import("./AutoStories-BUPTs54y.js")),
  Blank: B(() => import("./Blank-BaEhQYJX.js")),
  BuildCircle: B(() => import("./BuildCircle-DwpaqzDu.js")),
  Calculate: B(() => import("./Calculate-BvR7017o.js")),
  Cancel: B(() => import("./Cancel-eXVqEKn0.js")),
  Chat: B(() => import("./Chat-DmaUL586.js")),
  Check: B(() => import("./Check-DUSTv3ex.js")),
  Close: B(() => import("./Close-D3m_Sj3s.js")),
  Comment: B(() => import("./Comment-C98IlE7S.js")),
  Computer: B(() => import("./Computer-BQL77NuC.js")),
  ContactSupport: B(() => import("./ContactSupport-SJR8a83A.js")),
  Dictionary: B(() => import("./Dictionary-BpXwBzrF.js")),
  Diversity3: B(() => import("./Diversity3-0bAxUR8n.js")),
  DoNotDisturbOnFilled: B(
    () => import("./DoNotDisturbOnFilled-BVzOZi7h.js")
  ),
  DragHandle: B(() => import("./DragHandle-DO5AxAsb.js")),
  Draw: B(() => import("./Draw-ehJPt4IY.js")),
  DrawAbstract: B(() => import("./DrawAbstract-h3L1aInV.js")),
  Edit: B(() => import("./Edit-DBT7Gj5P.js")),
  Experiment: B(() => import("./Experiment-1ZcfZGw8.js")),
  FactCheck: B(() => import("./FactCheck-DJ-u24f1.js")),
  Info: B(() => import("./Info-LcOBSAl4.js")),
  InfoFilled: B(() => import("./InfoFilled-CvalG99E.js")),
  KeyboardArrowDown: B(
    () => import("./KeyboardArrowDown-DCpGF0wc.js")
  ),
  Language: B(() => import("./Language-B_64424A.js")),
  ListAltCheck: B(() => import("./ListAltCheck-CEBgw9uU.js")),
  MenuOpen: B(() => import("./MenuOpen-BL2JHlH0.js")),
  MenuBook: B(() => import("./MenuBook-Bw7QZTID.js")),
  MusicNote: B(() => import("./MusicNote-ByvAXzPW.js")),
  Palette: B(() => import("./Palette-DLtsKXF5.js")),
  Psychiatry: B(() => import("./Psychiatry-CHnRTShp.js")),
  Public: B(() => import("./Public-Bb5K6uMS.js")),
  Redo: B(() => import("./Redo-CYrD74Kf.js")),
  School: B(() => import("./School-MAExHB2y.js")),
  SourceEnvironment: B(
    () => import("./SourceEnvironment-BbhoUHcj.js")
  ),
  Spellcheck: B(() => import("./Spellcheck-DLrl9ozX.js")),
  SportsHandball: B(() => import("./SportsHandball-CVN0lVt5.js")),
  SupportAgent: B(() => import("./SupportAgent-gO07BplV.js")),
  Undo: B(() => import("./Undo-CJulw_HX.js")),
  Verified: B(() => import("./Verified-oV2qVwCk.js")),
  VisibilityOff: B(() => import("./VisibilityOff-Bm4xSg1U.js"))
}, we = ({ icon: e, ...t }) => {
  if (!e)
    return /* @__PURE__ */ f(Jn, {});
  const n = $i[e];
  return /* @__PURE__ */ f(oo, { fallback: /* @__PURE__ */ f(Jn, { ...t }), children: /* @__PURE__ */ f(n, { icon: e, ...t }) });
}, Xo = fn(void 0), Yo = () => {
  const e = mn(Xo);
  if (e === void 0)
    throw new Error("useActionMenuContext must be inside a ActionMenuProvider");
  return e;
}, ji = ({ children: e, defaultOpen: t, disableAutoClose: n, disabled: o }) => {
  const [r, s] = Ie(t ?? !1), { context: i, floatingStyles: a, refs: l } = Uo({
    placement: "bottom-start",
    open: r,
    onOpenChange: s,
    whileElementsMounted: Ao,
    middleware: [
      Po(5),
      Bo({ padding: 10 }),
      Ys({
        apply({ availableHeight: y, elements: w, rects: x }) {
          Object.assign(w.floating.style, {
            maxHeight: `${y}px`,
            minWidth: `${x.reference.width}px`
          });
        },
        padding: 10
      })
    ]
  }), c = vi(i, { event: "mousedown", enabled: !o }), d = zo(i, {
    enabled: !o && !n
  }), m = Ti(i, { role: "listbox", enabled: !o }), { getFloatingProps: b, getItemProps: u, getReferenceProps: p } = Ko(
    [d, m, c]
  ), g = pn(
    () => ({
      isOpen: r,
      setIsOpen: s,
      getFloatingProps: b,
      getItemProps: u,
      getReferenceProps: p,
      floatingStyles: a,
      refs: l,
      context: i
    }),
    [
      a,
      b,
      u,
      p,
      r,
      l,
      s,
      i
    ]
  );
  return /* @__PURE__ */ f(Xo.Provider, { value: g, children: e });
}, ct = ({
  children: e,
  defaultOpen: t,
  disableAutoClose: n = !1
}) => /* @__PURE__ */ f(
  ji,
  {
    defaultOpen: t,
    disableAutoClose: n,
    children: e
  }
), Tn = K.forwardRef(
  ({ children: e, onClick: t, ...n }, o) => {
    const { getReferenceProps: r, refs: s } = Yo(), { onClick: i, ...a } = r();
    return /* @__PURE__ */ f(
      "button",
      {
        ...n,
        ref: (l) => {
          s.setReference(l), typeof o == "function" ? o(l) : o && (o.current = l);
        },
        type: "button",
        ...a,
        "aria-haspopup": "listbox",
        role: "button",
        onClick: (l) => {
          typeof i == "function" && i(l), t == null || t(l);
        },
        children: e
      }
    );
  }
);
Tn.displayName = "ActionMenuTrigger";
const Sn = K.forwardRef(
  ({ children: e, ...t }, n) => {
    const {
      context: o,
      floatingStyles: r,
      getFloatingProps: s,
      isOpen: i,
      refs: a,
      setIsOpen: l
    } = Yo(), c = e({
      closeMenu: () => l(!1)
    });
    return i ? /* @__PURE__ */ f(Cn, { children: /* @__PURE__ */ f(qo, { context: o, modal: !1, children: /* @__PURE__ */ f(
      "div",
      {
        ref: (d) => {
          a.setFloating(d), typeof n == "function" ? n(d) : n && (n.current = d);
        },
        ...s(),
        ...t,
        role: "list",
        style: { ...r, ...t.style },
        children: c
      }
    ) }) }) : null;
  }
);
Sn.displayName = "ActionList";
const Zo = K.forwardRef(({ children: e, className: t, ...n }, o) => /* @__PURE__ */ f(
  Tn,
  {
    ref: o,
    className: [
      "cursor-pointer rounded-md bg",
      "aria-expanded:bg-gray-200 aria-expanded:text-gray-800",
      "hover:bg-gray-200",
      t
    ].filter(Boolean).join(" "),
    ...n,
    children: e
  }
));
Zo.displayName = "StyledTrigger";
const Qo = K.forwardRef(({ children: e, className: t, ...n }, o) => /* @__PURE__ */ f(
  Sn,
  {
    ref: o,
    className: [
      "bg-white rounded-lg shadow-[0_0_10px_rgba(0,0,0,0.2)]",
      t
    ].filter(Boolean).join(" "),
    ...n,
    children: (r) => /* @__PURE__ */ f("ul", { className: "flex flex-col items-center justify-center", children: e(r) })
  }
));
Qo.displayName = "StyledList";
const Jo = K.forwardRef(({ children: e, className: t, icon: n, isFirst: o, isLast: r, ...s }, i) => {
  const a = [
    "min-w-56 max-w-72",
    "not-first:border-t not-first:border-t not-first:border-gray-200",
    t
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ M("li", { ref: i, className: a, ...s, children: [
    K.Children.map(e, (l) => K.isValidElement(l) ? K.cloneElement(l, {
      className: [
        "flex gap-4 justify-between w-full py-3 px-4",
        "hover:bg-gray-100",
        o ? "rounded-t-lg" : "rounded-t-none",
        r ? "rounded-b-lg" : "rounded-b-none",
        "aria-disabled:cursor-not-allowed aria-disabled:text-gray-400",
        l.props.className
      ].filter(Boolean).join(" ")
    }) : l),
    n && /* @__PURE__ */ f(we, { icon: n })
  ] });
});
Jo.displayName = "StyledListItem";
ct.Trigger = Tn;
ct.StyledTrigger = Zo;
ct.List = Sn;
ct.StyledList = Qo;
ct.StyledListItem = Jo;
const er = ({ children: e, ...t }) => /* @__PURE__ */ f("nav", { "aria-label": "breadcrumb", ...t, children: /* @__PURE__ */ f("ol", { className: "flex flex-row list-none items-baseline group", children: e }) }), Gi = ({
  children: e,
  className: t,
  current: n,
  ...o
}) => {
  const r = de();
  return /* @__PURE__ */ M(
    "li",
    {
      ...o,
      "aria-current": n ? "page" : void 0,
      "aria-labelledby": r,
      className: [
        "first:list-none first:pl-0 whitespace-nowrap flex items-center",
        // if first item, no separator
        "first:[&>svg]:hidden!",
        t
      ].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ f(
          we,
          {
            className: "max-h-3 h-3 fill-blue-850!",
            icon: "ArrowForwardIos",
            role: "presentation"
          }
        ),
        n ? /* @__PURE__ */ f("span", { id: r, children: e }) : e
      ]
    }
  );
};
er.Item = Gi;
const $u = er, tr = K.forwardRef(
  (e, t) => {
    const {
      as: n,
      children: o,
      className: r,
      shape: s = "standard",
      variant: i = "primary",
      weight: a = "medium",
      ...l
    } = e, c = n || "button", d = ["cursor-pointer flex items-center whitespace-nowrap"];
    switch (s) {
      case "standard":
        d.push("px-3 py-2 rounded");
        break;
      case "pill":
        d.push("rounded-full px-3 py-2");
        break;
      case "round":
        d.push("rounded-full p-2 aspect-square");
        break;
    }
    switch (i) {
      case "primary":
        d.push(
          "bg-brand text-brand-contrast",
          "hover:bg-[#1b4559] focus:bg-[#1b4559]",
          "active:bg-[#36435c]",
          "disabled:bg-[#b3c1c8] disabled:pointer-events-none"
        );
        break;
      case "secondary":
        d.push(
          "text-primary border border-gray-200 border-solid bg-white",
          "hover:text-[#5a5a61] hover:border-[#c2c2d1]",
          "focus:text-[#5a5a61] focus:border-[#c2c2d1]",
          "active:text-[#3e6a8e]",
          "disabled:text-[#b3c1c8] disabled:border-[#b3c1c8] disabled:pointer-events-none"
        );
        break;
      case "ghost":
        d.push(
          "text-primary bg-transparent",
          "hover:text-[#0d0d0e] focus:text-[#0d0d0e]",
          "active:text-[#15394c]",
          "disabled:text-[#b3c1c8] disabled:pointer-events-none"
        );
        break;
    }
    switch (a) {
      case "bold":
        d.push("font-bold");
        break;
      case "medium":
        d.push("font-medium");
        break;
    }
    return /* @__PURE__ */ f(
      c,
      {
        ...l,
        ref: t,
        className: [...d, r].filter(Boolean).join(" "),
        children: o
      }
    );
  }
);
tr.displayName = "Button";
const Wi = (e) => (
  // eslint-disable-next-line react/display-name
  K.forwardRef(
    (t, n) => /* @__PURE__ */ f(tr, { ref: n, as: e, ...t })
  )
), Rn = Wi("button"), Vi = "_container_1bsv1_7", Hi = "_dark_1bsv1_11", qi = "_label_1bsv1_15", zi = "_actions_1bsv1_31", Ui = "_labelSm_1bsv1_35", Ki = "_labelXs_1bsv1_39", Xi = "_labelLg_1bsv1_43", Yi = "_lineClamp1_1bsv1_47", Zi = "_lineClamp2_1bsv1_51", Qi = "_lineClamp3_1bsv1_55", be = {
  container: Vi,
  dark: Hi,
  label: qi,
  actions: zi,
  labelSm: Ui,
  labelXs: Ki,
  labelLg: Xi,
  lineClamp1: Yi,
  lineClamp2: Zi,
  lineClamp3: Qi
}, En = ({
  children: e,
  className: t,
  variant: n = "light",
  ...o
}) => {
  const r = [be.container, t];
  switch (n) {
    case "light":
      r.push(be.light);
      break;
    case "dark":
      r.push(be.dark);
      break;
  }
  return /* @__PURE__ */ f(
    "div",
    {
      role: "group",
      ...o,
      className: r.filter(Boolean).join(" "),
      children: e
    }
  );
}, Ji = ({
  children: e,
  className: t,
  fontSize: n = "medium",
  lineClamp: o,
  ...r
}) => {
  const s = [be.label, t];
  switch (n) {
    case "extra-small":
      s.push(be.labelXs);
      break;
    case "small":
      s.push(be.labelSm);
      break;
    case "large":
      s.push(be.labelLg);
      break;
  }
  return o && (s.push(be[`lineClamp${o}`]), s.push("overflow-hidden")), K.cloneElement(e, {
    ...r,
    className: s.filter(Boolean).join(" ")
  });
}, ea = ({ children: e, className: t, ...n }) => {
  const o = [be.actions, t];
  return /* @__PURE__ */ f("div", { ...n, className: o.filter(Boolean).join(" "), children: e });
};
En.Label = Ji;
En.Actions = ea;
const ju = En, ta = "_container_aolsd_3", na = "_fullWidth_aolsd_7", oa = "_xLgWidth_aolsd_11", ra = "_mdTopPadding_aolsd_15", sa = "_mdBottomPadding_aolsd_19", Ye = {
  container: ta,
  fullWidth: na,
  xLgWidth: oa,
  mdTopPadding: ra,
  mdBottomPadding: sa
}, Gu = ({
  bottomPadding: e = "medium",
  children: t,
  className: n,
  topPadding: o = "medium",
  width: r = "auto",
  ...s
}) => {
  const i = [Ye.container, n];
  switch (r) {
    case "x-large":
      i.push(Ye.xLgWidth);
      break;
    case "full":
      i.push(Ye.fullWidth);
      break;
  }
  switch (o) {
    case "medium":
      i.push(Ye.mdTopPadding);
      break;
  }
  switch (e) {
    case "medium":
      i.push(Ye.mdBottomPadding);
      break;
  }
  return /* @__PURE__ */ f("div", { ...s, className: i.filter(Boolean).join(" "), children: t });
}, ia = "_container_kyg97_3", aa = "_oneColumn_kyg97_7", la = "_twoColumns_kyg97_11", ca = "_threeColumns_kyg97_15", ua = "_smallGap_kyg97_19", da = "_mediumGap_kyg97_23", fa = "_largeGap_kyg97_27", ma = "_smOneColumn_kyg97_31", pa = "_smTwoColumns_kyg97_35", ga = "_smThreeColumns_kyg97_39", ha = "_smFourColumns_kyg97_43", ba = "_smSmallGap_kyg97_47", va = "_smMediumGap_kyg97_51", ya = "_smLargeGap_kyg97_55", wa = "_mdOneColumn_kyg97_59", _a = "_mdTwoColumns_kyg97_63", xa = "_mdThreeColumns_kyg97_67", Ca = "_mdFourColumns_kyg97_71", Ta = "_mdSmallGap_kyg97_75", Sa = "_mdMediumGap_kyg97_79", Ra = "_mdLargeGap_kyg97_83", Ea = "_lgOneColumn_kyg97_87", ka = "_lgTwoColumns_kyg97_91", Ia = "_lgThreeColumns_kyg97_95", Na = "_lgFourColumns_kyg97_99", La = "_lgSmallGap_kyg97_103", Oa = "_lgMediumGap_kyg97_107", Aa = "_lgLargeGap_kyg97_111", Ma = "_xlOneColumn_kyg97_115", Pa = "_xlTwoColumns_kyg97_119", Ba = "_xlThreeColumns_kyg97_123", Fa = "_xlFourColumns_kyg97_127", Da = "_xlSmallGap_kyg97_131", $a = "_xlMediumGap_kyg97_135", ja = "_xlLargeGap_kyg97_139", Te = {
  container: ia,
  oneColumn: aa,
  twoColumns: la,
  threeColumns: ca,
  smallGap: ua,
  mediumGap: da,
  largeGap: fa,
  smOneColumn: ma,
  smTwoColumns: pa,
  smThreeColumns: ga,
  smFourColumns: ha,
  smSmallGap: ba,
  smMediumGap: va,
  smLargeGap: ya,
  mdOneColumn: wa,
  mdTwoColumns: _a,
  mdThreeColumns: xa,
  mdFourColumns: Ca,
  mdSmallGap: Ta,
  mdMediumGap: Sa,
  mdLargeGap: Ra,
  lgOneColumn: Ea,
  lgTwoColumns: ka,
  lgThreeColumns: Ia,
  lgFourColumns: Na,
  lgSmallGap: La,
  lgMediumGap: Oa,
  lgLargeGap: Aa,
  xlOneColumn: Ma,
  xlTwoColumns: Pa,
  xlThreeColumns: Ba,
  xlFourColumns: Fa,
  xlSmallGap: Da,
  xlMediumGap: $a,
  xlLargeGap: ja
}, nr = ["sm", "md", "lg", "xl"], Ga = (e) => nr.map((t) => {
  switch (e[t]) {
    case 1:
      return Te[`${t}OneColumn`];
    case 2:
      return Te[`${t}TwoColumns`];
    case 3:
      return Te[`${t}ThreeColumns`];
    case 4:
      return Te[`${t}FourColumns`];
    default:
      return;
  }
}).filter(Boolean), Wa = (e) => nr.map((t) => {
  switch (e[t]) {
    case "small":
      return Te[`${t}SmallGap`];
    case "medium":
      return Te[`${t}MediumGap`];
    case "large":
      return Te[`${t}LargeGap`];
    default:
      return;
  }
}).filter(Boolean), Va = Et(
  ({
    children: e,
    className: t,
    // if no value is provided for a key, the columns count will be inherited from the previous breakpoint, if any
    cols: n = { sm: 3 },
    // if no value is provided for a key, the gap size will be inherited from the previous breakpoint, if any
    gaps: o = { sm: "medium" },
    ...r
  }, s) => {
    const i = [Te.container, t], a = Ga(n);
    a.length > 0 && i.push(...a);
    const l = Wa(o);
    return l.length > 0 && i.push(...l), /* @__PURE__ */ f(
      "div",
      {
        ref: s,
        className: i.filter(Boolean).join(" "),
        ...r,
        children: e
      }
    );
  }
);
Va.displayName = "Grid";
const Ha = "_alternate_1wl2s_4", qa = "_gapSm_1wl2s_8", za = "_gapMd_1wl2s_12", Ua = "_gapLg_1wl2s_16", gt = {
  alternate: Ha,
  gapSm: qa,
  gapMd: za,
  gapLg: Ua
}, un = ({
  alignIcon: e = "right",
  children: t,
  gap: n = "md",
  icon: o,
  iconOnly: r = !1,
  size: s = "medium",
  ...i
}) => {
  const a = [i.className];
  switch (n) {
    case "sm":
      a.push(gt.gapSm);
      break;
    case "lg":
      a.push(gt.gapLg);
      break;
    default:
      a.push(gt.gapMd);
  }
  return e === "left" && a.push(gt.alternate), /* @__PURE__ */ M(Rn, { ...i, className: `${a.filter(Boolean).join(" ")}`, children: [
    r ? /* @__PURE__ */ f("span", { className: "sr-only", children: t }) : t,
    /* @__PURE__ */ f(we, { "aria-hidden": !0, icon: o, size: s })
  ] });
}, Ka = "_container_28583_3", Xa = "_spacingSmall_28583_7", Ya = "_spacingMedium_28583_11", Za = "_spacingLarge_28583_15", Qa = "_infoContent_28583_19", Ze = {
  container: Ka,
  spacingSmall: Xa,
  spacingMedium: Ya,
  spacingLarge: Za,
  infoContent: Qa
}, Wu = ({
  children: e,
  className: t,
  icon: n,
  spacing: o = "medium",
  ...r
}) => {
  const s = [Ze.container, t];
  switch (o) {
    case "small":
      s.push(Ze.spacingSmall);
      break;
    case "medium":
      s.push(Ze.spacingMedium);
      break;
    case "large":
      s.push(Ze.spacingLarge);
      break;
  }
  return /* @__PURE__ */ M("div", { className: s.filter(Boolean).join(" "), role: "region", ...r, children: [
    n && /* @__PURE__ */ f(we, { icon: n }),
    /* @__PURE__ */ f("div", { className: Ze.infoContent, children: e })
  ] });
}, Ja = "_tag_1rvle_3", el = "_casingUpper_1rvle_7", tl = "_weightBold_1rvle_15", nl = "_weightMedium_1rvle_11", ol = "_success_1rvle_27", rl = "_info_1rvle_31", sl = "_disabled_1rvle_35", il = "_pill_1rvle_39", al = "_paddingSm_1rvle_43", ll = "_paddingMd_1rvle_46", cl = "_paddingLg_1rvle_49", ie = {
  tag: Ja,
  casingUpper: el,
  weightBold: tl,
  weightMedium: nl,
  default: "_default_1rvle_23",
  success: ol,
  info: rl,
  disabled: sl,
  pill: il,
  paddingSm: al,
  paddingMd: ll,
  paddingLg: cl
}, or = K.forwardRef(
  ({
    "aria-label": e,
    "aria-labelledby": t,
    as: n = "span",
    children: o,
    className: r,
    disabled: s,
    padding: i = "sm",
    shape: a,
    textTransform: l = "uppercase",
    variant: c,
    weight: d = "bold",
    ...m
  }, b) => {
    const u = [ie.tag, r];
    switch (s && u.push(ie.disabled), c) {
      case "success":
        u.push(ie.success);
        break;
      case "info":
        u.push(ie.info);
        break;
      default:
        u.push(ie.default);
        break;
    }
    switch (a) {
      case "pill":
        u.push(ie.pill);
        break;
    }
    switch (i) {
      case "sm":
        u.push(ie.paddingSm);
        break;
      case "lg":
        u.push(ie.paddingLg);
        break;
      default:
        u.push(ie.paddingMd);
    }
    switch (l) {
      case "uppercase":
        u.push(ie.casingUpper);
        break;
    }
    switch (d) {
      case "bold":
        u.push(ie.weightBold);
        break;
      case "medium":
        u.push(ie.weightMedium);
        break;
    }
    return n === "button" ? /* @__PURE__ */ f(
      "button",
      {
        ref: b,
        className: u.filter(Boolean).join(" "),
        disabled: s,
        ...m,
        children: o
      }
    ) : /* @__PURE__ */ f(
      "span",
      {
        ref: b,
        "aria-label": t ? void 0 : e || (typeof o == "string" ? o : void 0),
        "aria-labelledby": t,
        className: u.filter(Boolean).join(" "),
        role: "note",
        ...m,
        children: o
      }
    );
  }
);
or.displayName = "Tag";
const ul = "_alternate_5bb9e_4", dl = "_gapSm_5bb9e_8", fl = "_gapMd_5bb9e_12", ml = "_gapLg_5bb9e_16", Qe = {
  alternate: ul,
  gapSm: dl,
  gapMd: fl,
  gapLg: ml
}, Vu = ({
  alignIcon: e = "right",
  children: t,
  gap: n = "md",
  icon: o,
  iconOnly: r = !1,
  size: s = "small",
  ...i
}) => {
  const a = [Qe.base, i.className], l = de();
  switch (n) {
    case "sm":
      a.push(Qe.gapSm);
      break;
    case "lg":
      a.push(Qe.gapLg);
      break;
    default:
      a.push(Qe.gapMd);
  }
  return e === "left" && a.push(Qe.alternate), /* @__PURE__ */ M(
    or,
    {
      "aria-labelledby": l,
      ...i,
      className: `${a.filter(Boolean).join(" ")}`,
      children: [
        r ? /* @__PURE__ */ f("span", { className: "sr-only", id: l, children: t }) : /* @__PURE__ */ f("span", { id: l, children: t }),
        /* @__PURE__ */ f(we, { "aria-hidden": !0, icon: o, size: s })
      ]
    }
  );
}, pl = "_hero_10m7w_3", gl = "_heroSm_10m7w_7", hl = "_display_10m7w_11", bl = "_headline_10m7w_19", vl = "_headlineSm_10m7w_23", yl = "_subheadline_10m7w_27", wl = "_subheadlineSm_10m7w_31", _l = "_body_10m7w_35", xl = "_footnote_10m7w_39", Cl = "_caption_10m7w_43", Tl = "_link_10m7w_47", le = {
  hero: pl,
  heroSm: gl,
  display: hl,
  headline: bl,
  headlineSm: vl,
  subheadline: yl,
  subheadlineSm: wl,
  body: _l,
  footnote: xl,
  caption: Cl,
  link: Tl
}, St = ({
  as: e,
  children: t,
  className: n,
  styleAs: o = "body",
  ...r
}) => {
  const s = [n];
  switch (o) {
    case "hero":
      s.push(le.hero);
      break;
    case "hero-sm":
      s.push(le.heroSm);
      break;
    case "headline":
      s.push(le.headline);
      break;
    case "headline-sm":
      s.push(le.headlineSm);
      break;
    case "subheadline":
      s.push(le.subheadline);
      break;
    case "subheadline-sm":
      s.push(le.subheadlineSm);
      break;
    case "body":
      s.push(le.body);
      break;
    case "footnote":
      s.push(le.footnote);
      break;
    case "caption":
      s.push(le.caption);
      break;
    case "link":
      s.push(le.link);
      break;
    case "display":
      s.push(le.display);
      break;
  }
  return /* @__PURE__ */ f(e || "p", { className: s.join(" "), ...r, children: t });
}, Sl = "_container_le97d_3", Rl = "_image_le97d_8", El = "_title_le97d_13", kl = "_type_le97d_18", Bt = {
  container: Sl,
  image: Rl,
  title: El,
  type: kl
}, Ft = ({
  children: e,
  className: t,
  role: n = "group",
  ...o
}) => {
  const r = [Bt.container, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f("div", { className: r, role: n, ...o, children: e });
}, Il = ({ alt: e = "", className: t, src: n, ...o }) => {
  const r = [Bt.image, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f("img", { ...o, alt: e, className: r, src: n });
}, Nl = ({ children: e, className: t, ...n }) => {
  const o = [Bt.title, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f(St, { as: "h2", styleAs: "body", ...n, className: o, children: e });
}, Ll = ({ children: e, className: t, ...n }) => {
  const o = [Bt.type, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f(St, { as: "p", styleAs: "subheadline", ...n, className: o, children: e });
};
Ft.Image = Il;
Ft.Title = Nl;
Ft.Type = Ll;
const Hu = Ft, Ol = "_loading_1nv68_12", Al = "_circle_1nv68_25", Jt = {
  loading: Ol,
  circle: Al,
  static: "_static_1nv68_29"
}, $e = ({
  "aria-label": e = "Loading skeleton",
  as: t = "div",
  className: n,
  height: o = "auto",
  isStatic: r = !1,
  shape: s = "square",
  width: i = "auto",
  ...a
}) => {
  const l = [Jt.loading, n];
  switch (r && l.push(Jt.static), s) {
    case "circle":
      l.push(Jt.circle);
      break;
  }
  const c = (a == null ? void 0 : a.style) ?? {};
  return /* @__PURE__ */ f(
    t,
    {
      ...a,
      "aria-label": e ?? "Loading skeleton",
      className: l.filter(Boolean).join(" "),
      role: "presentation",
      style: {
        ...c,
        height: o,
        width: i
      }
    }
  );
}, Ml = "_nav_1gxpm_3", Pl = "_stucky_1gxpm_11", Bl = "_menuLists_1gxpm_21", Fl = "_collapsed_1gxpm_25", Dl = "_heading_1gxpm_29", $l = "_menuGroup_1gxpm_37", jl = "_menuLink_1gxpm_45", Gl = "_menuLinkWithIcon_1gxpm_49", Wl = "_isActiveItem_1gxpm_65", Vl = "_largeSpacing_1gxpm_71", ue = {
  nav: Ml,
  stucky: Pl,
  menuLists: Bl,
  collapsed: Fl,
  heading: Dl,
  menuGroup: $l,
  menuLink: jl,
  menuLinkWithIcon: Gl,
  isActiveItem: Wl,
  largeSpacing: Vl
}, Dt = ({
  __isExpanded: e,
  ariaCloseLabel: t = "",
  children: n,
  hasCollapseButton: o,
  /**
   * Sticks the menu list.
   * Note: You will need to ensure Menu has a suitable height set!
   */
  isSticky: r,
  spacing: s = "medium",
  style: i = {},
  variant: a = "light",
  ...l
}) => {
  const c = [ue.nav, l.className], d = [], m = [ue.menuLists, "slow-transition"], b = de(), [u, p] = K.useState(e ?? !0), g = () => {
    p(!u);
  };
  switch (u || m.push(ue.collapsed), r && m.push(ue.stucky), s) {
    case "large":
      c.push(ue.largeSpacing);
      break;
  }
  switch (a) {
    case "dark":
      d.push("bg-[#F4F5FB]");
      break;
  }
  return /* @__PURE__ */ M(
    "div",
    {
      className: ["flex flex-col h-full rounded-xl", d].filter(Boolean).join(" "),
      style: i,
      children: [
        o ? /* @__PURE__ */ f("span", { className: "flex justify-end items-center pt-2 px-2", children: /* @__PURE__ */ f(
          un,
          {
            "aria-controls": b,
            "aria-expanded": u,
            "aria-label": t,
            className: "-scale-x-100 aria-expanded:scale-x-100 opacity-60 hover:bg-neutral-150 pt-3 pr-2",
            icon: "MenuOpen",
            variant: "ghost",
            onClick: g
          }
        ) }) : null,
        /* @__PURE__ */ f(
          "nav",
          {
            ...l,
            "aria-expanded": u,
            className: c.filter(Boolean).join(" "),
            children: /* @__PURE__ */ f("ul", { className: m.filter(Boolean).join(" "), id: b, children: n })
          }
        )
      ]
    }
  );
}, Hl = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f("li", { ...t, children: e }), rr = ({
  "aria-current": e,
  as: t = "a",
  children: n,
  className: o,
  ...r
}) => K.cloneElement(
  K.createElement(t),
  {
    ...r,
    "aria-current": e,
    className: [
      ue.menuLink,
      o,
      e ? ue.isActiveItem : ""
    ].filter(Boolean).join(" ")
  },
  n
), ql = ({
  children: e,
  icon: t,
  ...n
}) => {
  const o = [
    ue.menuLinkWithIcon,
    n.className,
    "standard-transition"
  ], r = de();
  return /* @__PURE__ */ M(
    rr,
    {
      ...n,
      "aria-labelledby": r,
      className: o.filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ f(we, { className: ue.icon, icon: t, role: "presentation" }),
        /* @__PURE__ */ f("span", { id: r, children: e })
      ]
    }
  );
}, zl = ({ children: e, id: t, label: n, ...o }) => {
  const r = [
    ue.menuGroup,
    o.className,
    "standard-transition"
  ], s = de(), i = t ?? s;
  return /* @__PURE__ */ M(
    "div",
    {
      ...o,
      "aria-labelledby": i,
      className: r.filter(Boolean).join(" "),
      role: "group",
      children: [
        /* @__PURE__ */ f(
          "h2",
          {
            className: [ue.heading, "fast-transition whitespace-nowrap"].filter(Boolean).join(" "),
            id: i,
            children: n
          }
        ),
        /* @__PURE__ */ f("ul", { children: e })
      ]
    }
  );
};
Dt.Item = Hl;
Dt.Group = zl;
Dt.Link = rr;
Dt.LinkWithIcon = ql;
const Ul = "_modalContainer_1npqv_3", Kl = "_modal_1npqv_3", Xl = "_header_1npqv_19", Yl = "_bannerImage_1npqv_23", Zl = "_shapesBanner_1npqv_24", Ql = "_mainImage_1npqv_28", Jl = "_overlayImage_1npqv_38", ec = "_title_1npqv_46", tc = "_closeButton_1npqv_50", nc = "_closeButtonIcon_1npqv_54", oc = "_limitBodyHeight_1npqv_63", rc = "_body_1npqv_67", sc = "_footer_1npqv_71", ic = "_smWidth_1npqv_76", ac = "_mdWidth_1npqv_80", lc = "_lgWidth_1npqv_84", te = {
  modalContainer: Ul,
  modal: Kl,
  header: Xl,
  bannerImage: Yl,
  shapesBanner: Zl,
  mainImage: Ql,
  overlayImage: Jl,
  title: ec,
  closeButton: tc,
  closeButtonIcon: nc,
  limitBodyHeight: oc,
  body: rc,
  footer: sc,
  smWidth: ic,
  mdWidth: ac,
  lgWidth: lc
}, cc = ({ children: e, className: t, ...n }) => {
  const o = [te.modalContainer, t];
  return /* @__PURE__ */ f(hr, { ...n, className: o.filter(Boolean).join(" "), children: /* @__PURE__ */ M(K.Fragment, { children: [
    /* @__PURE__ */ f(br, {}),
    typeof e == "function" ? e(n) : e
  ] }) });
}, Pe = ({
  children: e,
  className: t,
  // note: For i18n, there may be a way to set this globally at app initialization
  closeButtonLabel: n = "close",
  hasCloseButton: o = !0,
  initialFocus: r,
  onClose: s,
  width: i,
  ...a
}) => {
  const l = He(null), c = [te.modal, t];
  switch (i) {
    case "sm":
      c.push(te.smWidth);
      break;
    case "md":
      c.push(te.mdWidth);
      break;
    case "lg":
      c.push(te.lgWidth);
      break;
  }
  return /* @__PURE__ */ f(
    cc,
    {
      ...a,
      initialFocus: r || l,
      onClose: s,
      children: /* @__PURE__ */ M(gr, { className: c.filter(Boolean).join(" "), children: [
        o ? /* @__PURE__ */ M(
          "button",
          {
            ref: l,
            "aria-label": n,
            className: te.closeButton,
            type: "button",
            onClick: () => s(!0),
            children: [
              /* @__PURE__ */ f(we, { className: te.closeButtonIcon, icon: "Close" }),
              /* @__PURE__ */ f("span", { className: "sr-only", children: n })
            ]
          }
        ) : null,
        e
      ] })
    }
  );
}, uc = ({ children: e, className: t, ...n }) => {
  const o = [te.header, t];
  return /* @__PURE__ */ f("div", { ...n, className: o.filter(Boolean).join(" "), children: e });
}, dc = ({
  children: e,
  className: t,
  limitHeight: n,
  ...o
}) => {
  const r = [te.body, t];
  return n && r.push(te.limitBodyHeight), /* @__PURE__ */ f("div", { ...o, className: r.filter(Boolean).join(" "), children: e });
}, fc = ({ children: e, className: t, ...n }) => {
  const o = [te.footer, t];
  return /* @__PURE__ */ f("div", { ...n, className: o.filter(Boolean).join(" "), children: e });
}, mc = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "img",
  {
    className: [te.bannerImage, e].filter(Boolean).join(" "),
    ...t
  }
), pc = ({
  className: e,
  overlay: t,
  ...n
}) => /* @__PURE__ */ M("div", { className: te.shapesBanner, children: [
  /* @__PURE__ */ f(
    "img",
    {
      className: [te.mainImage, e].filter(Boolean).join(" "),
      ...n
    }
  ),
  t && /* @__PURE__ */ f("img", { className: te.overlayImage, src: t.toString() })
] }), gc = ({
  children: e,
  className: t
}) => {
  const n = [te.title, t];
  return /* @__PURE__ */ f(yr, { className: n.filter(Boolean).join(" "), children: e });
};
Pe.Header = uc;
Pe.Body = dc;
Pe.Footer = fc;
Pe.BannerImage = mc;
Pe.ShapesBanner = pc;
Pe.Title = gc;
Pe.Description = vr;
const qu = ({
  defaultValues: e,
  disabled: t,
  label: n,
  onChange: o,
  options: r,
  value: s,
  zindex: i,
  ...a
}) => {
  const [l, c] = Ie(
    Array.isArray(e) ? e : []
  );
  return Ve(() => {
    s !== void 0 && c(s);
  }, [s]), /* @__PURE__ */ f(at, { children: /* @__PURE__ */ M(
    ao,
    {
      multiple: !0,
      as: "div",
      className: "w-full relative",
      value: l,
      onChange: (d) => {
        c(d), o == null || o(d);
      },
      ...a,
      children: [
        /* @__PURE__ */ f(
          lo,
          {
            as: "button",
            className: [
              "w-full relative text-left cursor-pointer p-3",
              "bg-neutral-100 rounded-lg",
              "disabled:text-neutral-500 disabled:cursor-not-allowed"
            ].filter(Boolean).join(" "),
            disabled: t,
            children: /* @__PURE__ */ M("span", { className: "mr-12 flex gap-1", children: [
              n,
              /* @__PURE__ */ M(
                "span",
                {
                  className: [!l.length && "invisible"].filter(Boolean).join(" "),
                  children: [
                    "(",
                    l.length || 0,
                    ")"
                  ]
                }
              ),
              /* @__PURE__ */ f(mo, { className: "absolute right-3 top-1/2 transform -translate-y-1/2 group-has-disabled:text-neutral-500" })
            ] })
          }
        ),
        /* @__PURE__ */ f(
          co,
          {
            anchor: "bottom",
            className: [
              "bg-white shadow-lg rounded-xl border mt-1 py-4 px-2 w-(--button-width) flex gap-1 flex-col",
              !!i && `z-${i}`
            ].filter(Boolean).join(" "),
            modal: !1,
            children: r.map((d) => /* @__PURE__ */ M(
              uo,
              {
                className: "flex items-center py-3 px-4 hover:bg-neutral-50 cursor-pointer data-disabled:cursor-not-allowed data-disabled:text-neutral-500",
                "data-value": d.value,
                disabled: d.disabled,
                value: d.value,
                children: [
                  /* @__PURE__ */ f("span", { className: "inline-block mr-3", children: l.includes(d.value) ? /* @__PURE__ */ f(
                    "svg",
                    {
                      height: "18",
                      viewBox: "0 0 18 18",
                      width: "18",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ f(
                        "path",
                        {
                          d: "M7.6 10.7463L5.277 8.423C5.1385 8.28467 4.96442 8.21383 4.75475 8.2105C4.54525 8.20733 4.368 8.27817 4.223 8.423C4.07817 8.568 4.00575 8.74367 4.00575 8.95C4.00575 9.15633 4.07817 9.332 4.223 9.477L6.96725 12.2213C7.14808 12.4019 7.359 12.4923 7.6 12.4923C7.841 12.4923 8.05192 12.4019 8.23275 12.2213L13.7962 6.65775C13.9346 6.51925 14.0054 6.34517 14.0087 6.1355C14.0119 5.926 13.9411 5.74875 13.7962 5.60375C13.6512 5.45892 13.4756 5.3865 13.2693 5.3865C13.0629 5.3865 12.8873 5.45892 12.7423 5.60375L7.6 10.7463ZM2.30775 17.5C1.80258 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H15.6923C16.1974 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.80258 17.5 2.30775V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.30775ZM2.30775 16H15.6923C15.7692 16 15.8398 15.9679 15.9038 15.9038C15.9679 15.8398 16 15.7692 16 15.6923V2.30775C16 2.23075 15.9679 2.16025 15.9038 2.09625C15.8398 2.03208 15.7692 2 15.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V15.6923C2 15.7692 2.03208 15.8398 2.09625 15.9038C2.16025 15.9679 2.23075 16 2.30775 16Z",
                          fill: "#0A2E4B"
                        }
                      )
                    }
                  ) : /* @__PURE__ */ f(
                    "svg",
                    {
                      fill: "none",
                      height: "18",
                      viewBox: "0 0 18 18",
                      width: "18",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ f(
                        "path",
                        {
                          d: "M2.30775 17.5C1.80258 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H15.6923C16.1974 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.80258 17.5 2.30775V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.30775ZM2.30775 16H15.6923C15.7692 16 15.8398 15.9679 15.9038 15.9038C15.9679 15.8398 16 15.7692 16 15.6923V2.30775C16 2.23075 15.9679 2.16025 15.9038 2.09625C15.8398 2.03208 15.7692 2 15.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V15.6923C2 15.7692 2.03208 15.8398 2.09625 15.9038C2.16025 15.9679 2.23075 16 2.30775 16Z",
                          fill: "#0A2E4B"
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ f(gn, { variant: "base-normal", children: d.label })
                ]
              },
              d.value
            ))
          }
        )
      ]
    }
  ) });
}, hc = "_header_16shr_3", bc = "_breadcrumbs_16shr_9", vc = "_title_16shr_16", yc = "_subheading_16shr_21", wc = "_actions_16shr_30", _c = "_actionBar_16shr_36", Ke = {
  header: hc,
  breadcrumbs: bc,
  title: vc,
  subheading: yc,
  actions: wc,
  actionBar: _c
}, Xe = ({ children: e, className: t }) => {
  const n = [Ke.header, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f("div", { className: n, role: "banner", children: e });
}, xc = ({ children: e, className: t }) => K.cloneElement(e, {
  className: [t, Ke.title, e.props.className].filter(Boolean).join(" ")
}), Cc = ({ children: e, className: t, ...n }) => {
  const o = [Ke.subheading, t].filter(Boolean).join(" ");
  return /* @__PURE__ */ f("div", { ...n, className: o, children: e });
}, sr = ({ children: e, className: t, ...n }) => {
  const o = [Ke.actions, t];
  return /* @__PURE__ */ f(
    "div",
    {
      role: "toolbar",
      ...n,
      className: o.filter(Boolean).join(" "),
      children: e
    }
  );
}, Tc = ({ className: e, ...t }) => {
  const n = [Ke.actionBar, e].filter(Boolean).join(" ");
  return /* @__PURE__ */ f(sr, { ...t, className: n });
}, Sc = ({ children: e }) => /* @__PURE__ */ f("div", { className: Ke.breadcrumbs, children: e });
Xe.Title = xc;
Xe.SubHeader = Cc;
Xe.Actions = sr;
Xe.ActionBar = Tc;
Xe.Breadcrumb = Sc;
const zu = Xe, Rc = ({
  className: e,
  disabled: t,
  errorText: n,
  infoText: o,
  label: r
}) => /* @__PURE__ */ M("div", { className: ["group", e].filter(Boolean).join(" "), children: [
  /* @__PURE__ */ M("div", { className: "flex flex-col md:flex-row gap-4 relative bg-neutral-100 rounded-lg px-4 py-3", children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: [
          "block font-medium w-42 min-w-42",
          t ? "text-neutral-500" : "text-gray-700"
        ].join(" "),
        children: r ? /* @__PURE__ */ f("span", { children: r }) : /* @__PURE__ */ f($e, { height: "1.25rem", width: "8rem" })
      }
    ),
    /* @__PURE__ */ M("div", { className: "w-full bg-white rounded-[0.375rem] overflow-hidden", children: [
      /* @__PURE__ */ M("div", { className: "flex items-center gap-1 px-1 py-2 bg-[#f0f0f3]", children: [
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "undo button skeleton",
            className: "rounded bg-gray-200 w-7 h-7 ml-2",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "redo button skeleton",
            className: "rounded bg-gray-200 w-7 h-7",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "bold button skeleton",
            className: "rounded bg-gray-200 w-7 h-7 ml-1",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "italic button skeleton",
            className: "rounded bg-gray-200 w-7 h-7",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "strikethrough button skeleton",
            className: "rounded bg-gray-200 w-7 h-7 ml-2",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "list button skeleton",
            className: "rounded bg-gray-200 w-7 h-7 ml-2",
            role: "presentation"
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "aria-label": "link button skeleton",
            className: "rounded bg-gray-200 w-7 h-7 ml-1",
            role: "presentation"
          }
        )
      ] }),
      /* @__PURE__ */ f(
        "div",
        {
          "aria-label": "content area skeleton",
          className: "min-h-[200px] p-3 bg-white",
          role: "presentation",
          children: /* @__PURE__ */ M("div", { className: "space-y-3", children: [
            /* @__PURE__ */ f("div", { className: "flex items-center", children: /* @__PURE__ */ f($e, { height: "1rem", width: "100px" }) }),
            /* @__PURE__ */ M("div", { className: "space-y-2", children: [
              /* @__PURE__ */ f($e, { height: "1rem", width: "100%" }),
              /* @__PURE__ */ f($e, { height: "1rem", width: "85%" }),
              /* @__PURE__ */ f($e, { height: "1rem", width: "92%" })
            ] })
          ] })
        }
      )
    ] })
  ] }),
  o || n ? /* @__PURE__ */ M("div", { className: "mt-1 pl-4", children: [
    o && /* @__PURE__ */ f("span", { className: "text-neutral-750", children: o }),
    n && /* @__PURE__ */ f("span", { className: "text-red-500", children: n })
  ] }) : /* @__PURE__ */ f("div", { className: "mt-1 pl-4", children: /* @__PURE__ */ f($e, { height: "0.875rem", width: "12rem" }) })
] }), Ec = K.lazy(
  () => import("./RichTextField-CXeJxNn7.js").then((e) => ({
    default: e.RichTextField
  }))
), kc = ({
  className: e,
  disabled: t,
  errorText: n,
  infoText: o,
  label: r,
  ref: s,
  ...i
}) => /* @__PURE__ */ f(
  oo,
  {
    fallback: /* @__PURE__ */ f(
      Rc,
      {
        className: e,
        disabled: t,
        errorText: n,
        infoText: o,
        label: r
      }
    ),
    children: /* @__PURE__ */ f(
      Ec,
      {
        ref: s,
        className: e,
        disabled: t,
        errorText: n,
        infoText: o,
        label: r,
        ...i
      }
    )
  }
);
kc.displayName = "LazyRichTextField";
const $t = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ f(
  wr,
  {
    className: [
      "flex flex-col md:flex-row gap-4 relative bg-neutral-100 rounded-lg",
      "**:[:not(button)]:outline-0 **:[:not(button)]:ring-0",
      "focus-within:ring-2 focus-within:ring-blue-500",
      "group-[.small-sizing]:py-075 group-[.small-sizing]:px-100",
      "group-[.medium-sizing]:py-150 group-[.medium-sizing]:px-200",
      "group-[.large-sizing]:py-200 group-[.large-sizing]:px-250",
      "group-has-[.group-is-errored]:ring-2 group-has-[.group-is-errored]:ring-red-500",
      t
    ].filter(Boolean).join(" "),
    ...n,
    children: e
  }
), jt = ({
  className: e,
  errorText: t,
  infoText: n,
  ...o
}) => n || t ? /* @__PURE__ */ f(
  gn,
  {
    className: [
      "mt-1 pl-4",
      t ? "text-red-500 group-is-errored" : "text-neutral-750",
      e
    ].filter(Boolean).join(" "),
    variant: "sm-normal",
    ...o,
    children: t || n
  }
) : null, Gt = ({
  children: e,
  className: t,
  size: n = "medium",
  ...o
}) => {
  const r = [];
  switch (n) {
    case "small":
      r.push("text-md small-sizing");
      break;
    case "medium":
      r.push("text-md medium-sizing");
      break;
    case "large":
      r.push("text-xl large-sizing");
      break;
  }
  return /* @__PURE__ */ f(
    "div",
    {
      className: ["group", ...r, t].filter(Boolean).join(" "),
      ...o,
      children: e
    }
  );
}, Uu = ({
  className: e,
  defaultValue: t,
  disabled: n,
  errorText: o,
  infoText: r,
  label: s,
  onChange: i,
  options: a,
  size: l,
  value: c,
  ...d
}) => {
  const m = de(), [b, u] = Ie(
    a.find((p) => p.value === t) || a[0]
  );
  return Ve(() => {
    c !== void 0 && u(
      a.find((p) => p.value === c) || a[0]
    );
  }, [a, c]), /* @__PURE__ */ f(at, { children: /* @__PURE__ */ M(Gt, { disabled: n, size: l, children: [
    /* @__PURE__ */ M(
      $t,
      {
        "aria-describedby": m,
        className: "group-has-disabled:cursor-not-allowed",
        children: [
          /* @__PURE__ */ f("span", { className: "block font-medium w-42 min-w-42 text-gray-700 group-has-[:disabled]:text-neutral-500", children: s }),
          /* @__PURE__ */ M(
            ao,
            {
              defaultValue: t,
              ...d,
              as: "div",
              className: "w-full relative",
              value: b.value,
              onChange: (p) => {
                u(
                  a.find((g) => g.value === p) || a[0]
                ), i == null || i(p);
              },
              children: [
                /* @__PURE__ */ f(
                  lo,
                  {
                    as: "button",
                    className: [
                      "relative w-full text-left cursor-pointer",
                      "outline-none",
                      "disabled:text-neutral-500 disabled:cursor-not-allowed"
                    ].filter(Boolean).join(" "),
                    disabled: n,
                    children: /* @__PURE__ */ M("span", { children: [
                      b.label ?? "Select an option",
                      /* @__PURE__ */ f(mo, { className: "absolute right-0 top-1/2 transform -translate-y-1/2 group-has-[:disabled]:text-neutral-500" })
                    ] })
                  }
                ),
                /* @__PURE__ */ f(
                  co,
                  {
                    anchor: "bottom start",
                    className: "bg-white shadow-md rounded-md border bg-white border-neutral-200 px-150 py-200 w-(--button-width) flex gap-2 flex-col",
                    children: a.map((p) => /* @__PURE__ */ f(
                      uo,
                      {
                        className: "data-focus:bg-neutral-100 data-selected:not(:disabled):bg-neutral-150 data-disabled:bg-transparent py-150 px-200 rounded-md cursor-pointer data-disabled:cursor-not-allowed data-disabled:text-neutral-500",
                        disabled: p.disabled,
                        value: p.value,
                        children: p.label
                      },
                      p.value
                    ))
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f(
      jt,
      {
        errorText: o,
        id: m,
        infoText: r
      }
    )
  ] }) });
}, Ic = "_container_1yk0p_3", Nc = "_title_1yk0p_12", Lc = "_siteIdentity_1yk0p_16", Oc = "_actions_1yk0p_21", Wt = {
  container: Ic,
  title: Nc,
  siteIdentity: Lc,
  actions: Oc
}, Vt = ({
  children: e,
  className: t,
  ...n
}) => {
  const o = [Wt.container, t];
  return /* @__PURE__ */ f(
    "header",
    {
      role: "banner",
      ...n,
      className: o.filter(Boolean).join(" "),
      children: e
    }
  );
}, Ac = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f("div", { ...t, className: Wt.siteIdentity, children: e }), Mc = ({
  children: e,
  className: t,
  ...n
}) => {
  const o = [Wt.title, t, e.props.className];
  return K.cloneElement(e, {
    ...n,
    className: o.filter(Boolean).join(" ")
  });
}, Pc = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f("div", { ...t, className: Wt.actions, children: e });
Vt.Identity = Ac;
Vt.Actions = Pc;
Vt.Title = Mc;
const Ku = Vt, ir = ({
  offset: e = 8,
  open: t = !1,
  placement: n = "top"
}) => {
  const [o, r] = Ie(t), s = He(null), { context: i, floatingStyles: a, refs: l } = Uo({
    open: o,
    onOpenChange: r,
    placement: n,
    middleware: [
      Zs({
        element: s
      }),
      Bo(),
      Po(e),
      Xs()
    ],
    whileElementsMounted: Ao
  }), c = li(i, {
    delay: 200
  }), d = xi(i), m = zo(i, {
    ancestorScroll: !0
  }), { getFloatingProps: b, getReferenceProps: u } = Ko([
    c,
    d,
    m
  ]);
  return {
    arrowRef: s,
    arrowLeftOffest: "calc(50% - 7px)",
    context: i,
    floatingStyles: a,
    getFloatingProps: b,
    getReferenceProps: u,
    isOpen: o,
    refs: l
  };
}, Bc = "_arrow_3ldbg_3", Fc = {
  arrow: Bc
}, Dc = ({
  children: e,
  description: t,
  open: n = !1,
  tooltipClasses: o,
  ...r
}) => {
  const s = Ue(), {
    arrowLeftOffest: i,
    arrowRef: a,
    context: l,
    floatingStyles: c,
    getFloatingProps: d,
    getReferenceProps: m,
    isOpen: b,
    refs: u
  } = ir({
    open: n
  }), p = [
    "rounded border bg-[#333333] text-white border-transparent",
    o
  ], g = [Fc.arrow], y = n || b;
  return /* @__PURE__ */ M(it, { children: [
    /* @__PURE__ */ f(
      ar,
      {
        ref: u.setReference,
        "aria-describedby": y ? s : void 0,
        getReferenceProps: m,
        isOpen: b,
        tabIndex: 0,
        ...r,
        children: e
      }
    ),
    y && /* @__PURE__ */ f(Cn, { children: /* @__PURE__ */ M(
      "div",
      {
        ...d({
          autoFocus: !1,
          className: p.filter(Boolean).join(" "),
          id: s
        }),
        ref: u.setFloating,
        role: "tooltip",
        style: {
          ...c,
          zIndex: 1e3
          // issues when modals are open in a portal
        },
        children: [
          t,
          /* @__PURE__ */ f(
            Do,
            {
              ref: a,
              className: g.filter(Boolean).join(" "),
              context: l,
              style: {
                left: i
              }
            }
          )
        ]
      }
    ) })
  ] });
}, ar = K.forwardRef(({ children: e, getReferenceProps: t, isOpen: n, ...o }, r) => K.isValidElement(e) ? (
  // If the user passes a valid element, we clone it and add the necessary props
  K.cloneElement(
    e,
    t({
      ref: r,
      ...o,
      ...e.props,
      "data-state": n ? "open" : "closed"
    })
  )
) : /* @__PURE__ */ f(
  "button",
  {
    ...t(),
    ref: r,
    ...o,
    type: "button",
    children: e
  }
));
ar.displayName = "TooltipTrigger";
const $c = "_stepsList_1nhk0_3", jc = "_step_1nhk0_3", Gc = "_srOnly_1nhk0_11", Wc = "_activatedStep_1nhk0_15", Vc = "_smallGap_1nhk0_19", Hc = "_largeGap_1nhk0_23", qc = "_smallDots_1nhk0_27", zc = "_largeDots_1nhk0_31", me = {
  stepsList: $c,
  step: jc,
  srOnly: Gc,
  activatedStep: Wc,
  smallGap: Vc,
  largeGap: Hc,
  smallDots: qc,
  largeDots: zc
}, Uc = ({
  className: e,
  isActivated: t,
  step: n,
  ...o
}) => {
  const r = [me.step, e];
  return t && r.push(me.activatedStep), /* @__PURE__ */ f("div", { ...o, "aria-hidden": "true", className: r.join(" "), children: /* @__PURE__ */ f("span", { className: me.srOnly, children: n }) });
}, Kc = ({
  currentStep: e,
  dotSize: t = "large",
  gapSize: n = "large",
  steps: o,
  ...r
}) => {
  const s = e < 1 ? 1 : e, i = `Step ${s} of ${o}`, a = [me.stepsList], l = [me.stepsList];
  switch (t) {
    case "small":
      l.push(me.smallDots);
      break;
    case "large":
      l.push(me.largeDots);
      break;
  }
  switch (n) {
    case "small":
      a.push(me.smallGap);
      break;
    case "large":
      a.push(me.largeGap);
      break;
  }
  return /* @__PURE__ */ M(it, { children: [
    /* @__PURE__ */ f(Dc, { description: i, children: /* @__PURE__ */ f(
      "div",
      {
        ...r,
        className: a.filter(Boolean).join(" "),
        role: "presentation",
        tabIndex: 0,
        children: Array.from({ length: o }).map((c, d) => /* @__PURE__ */ f(
          Uc,
          {
            className: l.filter(Boolean).join(" "),
            isActivated: s >= d + 1,
            step: d + 1
          },
          d
        ))
      }
    ) }),
    /* @__PURE__ */ f("div", { "aria-live": "polite", className: me.srOnly, children: i })
  ] });
}, Xc = "_tabTrigger_8f9pq_3", Yc = "_tabList_8f9pq_25", dn = {
  tabTrigger: Xc,
  tabList: Yc
}, Zc = ({
  children: e,
  defaultIndex: t = 0,
  onChange: n,
  ...o
}) => /* @__PURE__ */ f(
  _r,
  {
    defaultIndex: t,
    onChange: (r) => n == null ? void 0 : n(r),
    ...o,
    children: e
  }
), Qc = ({
  children: e,
  className: t,
  ...n
}) => {
  const o = [dn.tabList, t];
  return /* @__PURE__ */ f(xr, { className: o.filter(Boolean).join(" "), ...n, children: e });
}, Jc = ({
  children: e,
  className: t,
  disabled: n = !1,
  ...o
}) => /* @__PURE__ */ f(
  Cr,
  {
    className: ({ disabled: r }) => {
      const s = [dn.tabTrigger, t];
      return r && s.push(dn.disabled), s.filter(Boolean).join(" ");
    },
    disabled: n,
    ...o,
    children: e
  }
), eu = ({ children: e, ...t }) => /* @__PURE__ */ f(fo, { ...t, children: e }), tu = ({ children: e, ...t }) => /* @__PURE__ */ f(fo, { ...t, children: e }), Xu = Object.assign(Zc, {
  Content: tu,
  Trigger: Jc,
  TriggerList: Qc,
  Panels: eu
}), Yu = ({
  className: e,
  errorText: t,
  infoText: n,
  label: o,
  size: r,
  ...s
}) => {
  const i = de();
  return /* @__PURE__ */ f(at, { as: it, children: /* @__PURE__ */ M(Gt, { className: e, label: o, size: r, children: [
    /* @__PURE__ */ M(
      $t,
      {
        "aria-describedby": i,
        className: "group-has-disabled:cursor-not-allowed",
        children: [
          /* @__PURE__ */ f("span", { className: "block font-medium w-42 min-w-42 text-gray-700 group-has-[:disabled]:text-neutral-500", children: o }),
          /* @__PURE__ */ f(
            Tr,
            {
              className: [
                e,
                "block w-full border-none bg-neutral-100 h-24 mb-2 focus-within:outline-none disabled:text-neutral-500 disabled:cursor-not-allowed"
              ].filter(Boolean).join(" "),
              ...s
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f(
      jt,
      {
        errorText: t,
        id: i,
        infoText: n
      }
    )
  ] }) });
}, Zu = ({
  className: e,
  errorText: t,
  infoText: n,
  label: o,
  size: r,
  ...s
}) => {
  const i = de();
  return /* @__PURE__ */ f(at, { as: ro, children: /* @__PURE__ */ M(Gt, { className: e, size: r, children: [
    /* @__PURE__ */ M(
      $t,
      {
        "aria-describedby": i,
        className: "group-has-disabled:cursor-not-allowed",
        children: [
          /* @__PURE__ */ f("span", { className: "block font-medium w-42 min-w-42 text-gray-700 group-has-disabled:text-neutral-500", children: o }),
          /* @__PURE__ */ f(
            Sr,
            {
              ...s,
              className: [
                "block w-full border-none bg-neutral-100 focus-within:outline-none disabled:text-neutral-500 disabled:cursor-not-allowed",
                e
              ].filter(Boolean).join(" "),
              type: "text"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f(
      jt,
      {
        errorText: t,
        id: i,
        infoText: n
      }
    )
  ] }) });
}, nu = "_toast_zwlbb_27", ou = "_fadeOut_zwlbb_31", ru = "_slideIn_zwlbb_37", su = "_closeButton_zwlbb_44", iu = "_icon_zwlbb_48", au = "_successIcon_zwlbb_52", lu = "_errorIcon_zwlbb_56", Le = {
  toast: nu,
  fadeOut: ou,
  slideIn: ru,
  closeButton: su,
  icon: iu,
  successIcon: au,
  errorIcon: lu
}, cu = ({
  children: e,
  className: t,
  fadeOutActive: n,
  fadeOutDurationMs: o = 800,
  handleClose: r,
  id: s,
  slideInActive: i,
  type: a,
  ...l
}) => {
  const c = [Le.toast, t], d = [Le.icon], m = de(), b = de(), u = a === "success" ? "Check" : a === "error" ? "Cancel" : null;
  a === "success" ? d.push(Le.successIcon) : d.push(Le.errorIcon), n && c.push(Le.fadeOut), i && c.push(Le.slideIn);
  const p = n && o > 0;
  return /* @__PURE__ */ M(
    "div",
    {
      "aria-atomic": "true",
      "aria-describedby": b,
      "aria-labelledby": m,
      "aria-live": "assertive",
      className: c.filter(Boolean).join(" "),
      id: s,
      role: "alert",
      ...l,
      style: {
        // Note: not added in the module.css so that it can be dynamically and kept in sync with the setTimeout duration
        animationDuration: `${o}ms`
      },
      children: [
        u && /* @__PURE__ */ f(we, { className: d.filter(Boolean).join(" "), icon: u }),
        /* @__PURE__ */ f("span", { className: "sr-only", id: m, children: a === "error" ? "Error notification" : "Success notification" }),
        /* @__PURE__ */ f("span", { id: b, role: "document", children: e }),
        /* @__PURE__ */ f(
          Rn,
          {
            "aria-label": "Close notification",
            className: Le.closeButton,
            disabled: p,
            variant: "ghost",
            onClick: r,
            children: /* @__PURE__ */ f(we, { icon: "Close" })
          }
        )
      ]
    }
  );
}, uu = "_label_12a52_3", du = "_input_12a52_7", fu = "_toggle_12a52_11", en = {
  label: uu,
  input: du,
  toggle: fu
}, mu = Et(
  ({ children: e, className: t, id: n, ...o }, r) => {
    const s = de(), i = n || s, a = [en.input], l = [en.label, t];
    return /* @__PURE__ */ M(it, { children: [
      /* @__PURE__ */ f(
        "label",
        {
          className: l.filter(Boolean).join(" "),
          htmlFor: i,
          id: `${i}-label`,
          children: e
        }
      ),
      /* @__PURE__ */ f(
        "input",
        {
          ref: r,
          "aria-labelledby": `${i}-label`,
          className: a.filter(Boolean).join(" "),
          id: i,
          type: "checkbox",
          ...o
        }
      ),
      /* @__PURE__ */ f(
        "label",
        {
          "aria-hidden": "true",
          className: en.toggle,
          htmlFor: i,
          id: `${i}-switch`,
          role: "switch"
        }
      )
    ] });
  }
);
mu.displayName = "Toggle";
const Qu = ({
  checked: e,
  className: t,
  defaultChecked: n,
  disabled: o = !1,
  errorText: r,
  infoText: s,
  label: i,
  onChange: a,
  options: l,
  size: c,
  ...d
}) => {
  const [m, b] = Ie(
    n || e || !1
  );
  return Ve(() => {
    e !== void 0 && b(e);
  }, [e]), /* @__PURE__ */ f(at, { as: ro, children: /* @__PURE__ */ M(Gt, { className: t, disabled: o, size: c, children: [
    /* @__PURE__ */ M($t, { className: "group-has-disabled:cursor-not-allowed", children: [
      /* @__PURE__ */ f(
        "span",
        {
          className: "block font-medium w-42 min-w-42 group-has-[:disabled]:text-neutral-500",
          children: i
        }
      ),
      /* @__PURE__ */ M("div", { className: "flex-grow justify-between flex", children: [
        /* @__PURE__ */ f(gn, { className: "text-blue-850 group-has-[:disabled]:text-neutral-500", children: l[m ? "on" : "off"] }),
        /* @__PURE__ */ f(
          Rr,
          {
            checked: m,
            className: "group inline-flex h-[31px] w-13 items-center rounded-full bg-neutral-150 transition data-checked:bg-green-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 -my-1 data-checked:disabled:bg-gray-300",
            disabled: o,
            onChange: (u) => {
              b(u), a == null || a(u);
            },
            ...d,
            children: /* @__PURE__ */ f(
              "span",
              {
                className: "size-[27px] translate-x-[2px] rounded-full bg-white transition group-data-checked:translate-x-[23px]",
                style: {
                  boxShadow: "0 5px 10px rgba(0, 0, 0, 0.2)"
                }
              }
            )
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ f(jt, { errorText: r, infoText: s })
  ] }) });
}, lr = fn(void 0), cr = () => {
  const e = mn(lr);
  if (e === void 0)
    throw new Error("useTourGuide must be inside a TourGuideProvider");
  return e;
}, pu = {
  currentTourId: null,
  currentStepId: null,
  registeredTours: {}
};
function bt(e) {
  return [...e || []].sort((t, n) => t.priority - n.priority);
}
function gu(e, t) {
  switch (t.type) {
    case "REGISTER_STEPS": {
      const n = { ...e.registeredTours };
      for (const { step: o, tourId: r } of t.payload) {
        const s = n[r] || { id: r, steps: [] };
        s.steps.some((i) => i.id === o.id) || s.steps.push(o), n[r] = s;
      }
      return { ...e, registeredTours: n };
    }
    case "UNREGISTER_STEP": {
      const { stepId: n, tourId: o } = t.payload, r = e.registeredTours[o];
      if (!r) return e;
      const s = r.steps.filter((i) => i.id !== n);
      if (s.length === 0) {
        const { [o]: i, ...a } = e.registeredTours;
        return { ...e, registeredTours: a };
      }
      return {
        ...e,
        registeredTours: {
          ...e.registeredTours,
          [o]: { ...r, steps: s }
        }
      };
    }
    case "START_TOUR": {
      const { stepId: n, tourId: o } = t.payload, r = e.registeredTours[o];
      if (!r) return { ...e, currentTourId: null, currentStepId: null };
      const s = bt(r.steps), i = n != null ? s.find((a) => a.id === n) : s[0];
      return i ? { ...e, currentTourId: o, currentStepId: i.id } : { ...e, currentTourId: null, currentStepId: null };
    }
    case "NEXT_STEP": {
      const { currentStepId: n, currentTourId: o, registeredTours: r } = e;
      if (!o || !n) return e;
      const s = r[o];
      if (!s) return e;
      const i = bt(s.steps), a = i.findIndex((l) => l.id === n);
      return a === -1 || a === i.length - 1 ? { ...e, currentTourId: null, currentStepId: null } : {
        ...e,
        currentStepId: i[a + 1].id
      };
    }
    case "PREVIOUS_STEP": {
      const { currentStepId: n, currentTourId: o, registeredTours: r } = e;
      if (!o || !n) return e;
      const s = r[o];
      if (!s) return e;
      const i = bt(s.steps), a = i.findIndex((l) => l.id === n);
      return a <= 0 ? { ...e, currentTourId: null, currentStepId: null } : {
        ...e,
        currentStepId: i[a - 1].id
      };
    }
    case "DISMISS_TOUR":
      return { ...e, currentTourId: null, currentStepId: null };
    default:
      return e;
  }
}
const Ju = ({
  children: e,
  overlayZIndex: t = 1
}) => {
  const [n, o] = mr(gu, pu), r = pn(() => {
    const s = () => {
      const a = n.currentTourId ? n.registeredTours[n.currentTourId] : null;
      return a ? {
        ...a,
        totalSteps: a.steps.length
      } : null;
    }, i = () => {
      const a = s();
      if (!a || !n.currentStepId) return null;
      const l = bt(a.steps), c = l.findIndex((m) => m.id === n.currentStepId), d = l[c];
      return d ? {
        ...d,
        isLastStep: c === l.length - 1,
        index: c
      } : null;
    };
    return {
      tours: n.registeredTours,
      currentTourId: n.currentTourId,
      currentStepId: n.currentStepId,
      getCurrentTour: s,
      getCurrentStep: i,
      startTour: (a) => o({ type: "START_TOUR", payload: a }),
      nextStep: () => o({ type: "NEXT_STEP" }),
      previousStep: () => o({ type: "PREVIOUS_STEP" }),
      dismissTour: () => o({ type: "DISMISS_TOUR" }),
      registerStepEntries: (a) => o({ type: "REGISTER_STEPS", payload: a }),
      unregisterStepEntry: (a) => o({ type: "UNREGISTER_STEP", payload: a }),
      overlayZIndex: t
    };
  }, [
    n.registeredTours,
    n.currentTourId,
    n.currentStepId,
    t
  ]);
  return /* @__PURE__ */ M(lr.Provider, { value: r, children: [
    r.getCurrentTour() !== null && /* @__PURE__ */ f(hu, { overlayZIndex: r.overlayZIndex }),
    e
  ] });
}, hu = ({ overlayZIndex: e }) => io(
  /* @__PURE__ */ f(
    "div",
    {
      "aria-label": "Tour guide overlay",
      role: "presentation",
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
        zIndex: e
      }
    }
  ),
  document.body
), bu = "_popover_lwhq5_3", vu = {
  popover: bu
}, ur = Et(
  ({
    children: e,
    className: t,
    description: n,
    heading: o,
    isLastStep: r,
    onNextStep: s,
    onPreviousStep: i,
    onSkipTour: a,
    step: l,
    totalSteps: c,
    ...d
  }, m) => {
    const b = [vu.popover, t];
    return /* @__PURE__ */ M(
      "div",
      {
        ...d,
        ref: m,
        className: b.filter(Boolean).join(" "),
        children: [
          /* @__PURE__ */ f("div", { style: { display: "flex", justifyContent: "flex-end" }, children: /* @__PURE__ */ f(
            Kc,
            {
              currentStep: l,
              dotSize: "small",
              gapSize: "small",
              steps: c
            }
          ) }),
          /* @__PURE__ */ f(St, { as: "h2", styleAs: "subheadline", children: o }),
          /* @__PURE__ */ f(St, { styleAs: "body", children: n }),
          /* @__PURE__ */ M(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                marginTop: "16px"
              },
              children: [
                a && /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(Rn, { variant: "ghost", onClick: a, children: "Skip" }) }),
                /* @__PURE__ */ M(
                  "div",
                  {
                    style: {
                      display: "flex",
                      gap: "8px",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "flex-end"
                    },
                    children: [
                      l > 1 && i && /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
                        un,
                        {
                          iconOnly: !0,
                          icon: "ArrowForwardIos",
                          shape: "round",
                          size: "small",
                          style: {
                            // flip 180
                            transform: "rotate(180deg)"
                          },
                          variant: "ghost",
                          onClick: i,
                          children: "Previous"
                        }
                      ) }),
                      /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
                        un,
                        {
                          iconOnly: !0,
                          icon: r ? "Check" : "ArrowForwardIos",
                          shape: "round",
                          size: "small",
                          onClick: s,
                          children: r ? "Finish" : "Next"
                        }
                      ) })
                    ]
                  }
                )
              ]
            }
          ),
          e
        ]
      }
    );
  }
);
ur.displayName = "TourPopover";
const yu = (e) => {
  const { registerStepEntries: t, unregisterStepEntry: n } = cr(), [o, r] = Ie(!1);
  return Ve(() => (e.length > 0 && !o && (t(e), r(!0)), () => {
    if (e.length > 0)
      for (const s of e)
        n({
          tourId: s.tourId,
          stepId: s.step.id
        });
  }), []), o;
};
function wu(e) {
  const t = He(!1), n = (o) => {
    !o || t.current || setTimeout(() => {
      if (e) {
        const r = o.getBoundingClientRect(), s = r.top >= 0 && r.left >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight) && r.right <= (window.innerWidth || document.documentElement.clientWidth);
        !s && (document.activeElement === o || o instanceof HTMLElement && o.tabIndex === 0) ? (o.scrollIntoView({
          block: "nearest",
          behavior: "smooth"
        }), t.current = !0) : s && (t.current = !0);
      }
    }, 0);
  };
  return Ve(() => {
    e && (t.current = !1);
  }, [e]), { scrollNodeIntoViewOnLoad: n };
}
const _u = "_stepActive_7wmxc_3", xu = "_arrow_7wmxc_8", eo = {
  stepActive: _u,
  arrow: xu
}, to = 12, Cu = 20, Tu = Et(
  ({
    activeElementStyles: e,
    children: t,
    offset: n = to + 8,
    placement: o = "top",
    tourStep: r,
    tourStepEntries: s = [],
    ...i
  }, a) => {
    var q;
    const l = Ue(), c = He(null), {
      dismissTour: d,
      getCurrentStep: m,
      getCurrentTour: b,
      nextStep: u,
      overlayZIndex: p = 0,
      previousStep: g,
      tours: y
    } = cr();
    yu(s);
    const w = b(), x = m(), {
      arrowRef: _,
      context: T,
      floatingStyles: k,
      getFloatingProps: P,
      getReferenceProps: N,
      refs: F
    } = ir({ placement: o, offset: n }), V = r && (x == null ? void 0 : x.id) === r.stepId ? ((q = y[r.tourId]) == null ? void 0 : q.steps.find(
      (L) => L.id === r.stepId
    )) ?? null : s.find(
      ({ step: L, tourId: E }) => (w == null ? void 0 : w.id) === E && (x == null ? void 0 : x.id) === L.id
    ), $ = !!(w && x && V), { scrollNodeIntoViewOnLoad: j } = wu($), S = {};
    return $ && (S.zIndex = `${p + 1}`), /* @__PURE__ */ M(it, { children: [
      K.cloneElement(
        t,
        N({
          ref: (L) => {
            F.setReference(L), c.current = L, j(L), typeof a == "function" ? a(L) : a && (a.current = L);
          },
          ...i,
          ...t.props,
          className: [
            $ ? eo.stepActive : !1,
            t.props.className
          ].filter(Boolean).join(" "),
          style: {
            ...t.props.style,
            ...i.style,
            ...S,
            ...$ ? e : {}
          },
          "aria-describedby": $ ? l : void 0
        })
      ),
      x && w && $ && /* @__PURE__ */ f(Cn, { children: /* @__PURE__ */ f(
        qo,
        {
          context: T,
          initialFocus: 0,
          returnFocus: x.isLastStep,
          children: /* @__PURE__ */ f(
            ur,
            {
              ...P({
                autoFocus: !1,
                id: l
              }),
              ref: F.setFloating,
              description: x.description,
              heading: x.title,
              isLastStep: x.isLastStep,
              role: "tooltip",
              step: x.index + 1,
              style: {
                ...k,
                maxWidth: "328px",
                width: "100%",
                zIndex: p + 1
              },
              totalSteps: w.totalSteps,
              onNextStep: u,
              onPreviousStep: g,
              onSkipTour: x.isLastStep ? void 0 : d,
              children: /* @__PURE__ */ f(
                Do,
                {
                  ref: _,
                  className: eo.arrow,
                  context: T,
                  height: to,
                  stroke: "var(--theme-border-primary, #CCD6DA)",
                  strokeWidth: 1,
                  width: Cu
                }
              )
            }
          )
        }
      ) })
    ] });
  }
);
Tu.displayName = "TourStep";
const dr = fn(
  void 0
), fr = () => {
  const e = mn(dr);
  if (e === void 0)
    throw new Error("useToasts must be inside a ToastsContextProvider");
  return e;
}, Su = ({
  displayDuration: e,
  fadeDuration: t,
  id: n
}) => {
  const { removeToast: o } = fr(), [r, s] = Ie(!1), i = He(
    null
  ), a = pr(() => {
    r || (s(!0), setTimeout(() => {
      o(n);
    }, t));
  }, [t, r, n, o]);
  return e !== 0 && (i.current = setTimeout(a, e)), {
    handleClose: a,
    fadeOutActive: r,
    fadeDuration: t
  };
}, Ru = ({
  children: e,
  duration: t = 5e3,
  id: n,
  ...o
}) => {
  const { fadeDuration: r, fadeOutActive: s, handleClose: i } = Su({
    id: n,
    displayDuration: t,
    fadeDuration: 800
  });
  return /* @__PURE__ */ f(
    cu,
    {
      fadeOutActive: s,
      fadeOutDurationMs: r,
      handleClose: i,
      id: n,
      ...o,
      children: e
    }
  );
}, Eu = "_container_1c0s2_3", ku = {
  container: Eu
}, Iu = () => {
  const { toasts: e } = fr();
  return e.length > 0 ? io(
    /* @__PURE__ */ f("div", { className: ku.container, children: e.map(({ duration: n, id: o, message: r, type: s }) => /* @__PURE__ */ f(Ru, { duration: n, id: o, type: s, children: r }, o)) }),
    document.body
  ) : null;
}, Rt = [], Nu = (e) => `${e}-${Math.random().toString(36).slice(2, 9)}`, Lu = (e) => {
  let t;
  do
    t = Nu(e);
  while (Rt.includes(t));
  return Rt.push(t), t;
}, Ou = (e) => {
  Rt.splice(Rt.indexOf(e), 1);
}, ed = ({ children: e }) => {
  const [t, n] = Ie([]), o = pn(() => {
    const r = ({
      duration: l = 3e3,
      message: c,
      type: d = "success"
    }) => {
      const b = {
        id: Lu(d),
        message: c,
        duration: l,
        type: d
      };
      n((u) => [...u, b]);
    };
    return {
      addSuccessToast: ({ duration: l, message: c }) => {
        r({ duration: l, message: c, type: "success" });
      },
      addErrorToast: ({ duration: l, message: c }) => {
        r({ duration: l, message: c, type: "error" });
      },
      removeToast: (l) => {
        n((c) => c.filter((d) => d.id !== l)), Ou(l);
      },
      toasts: t
    };
  }, [t]);
  return /* @__PURE__ */ M(dr.Provider, { value: o, children: [
    e,
    /* @__PURE__ */ f(Iu, {})
  ] });
};
export {
  ct as A,
  Bi as B,
  ju as C,
  fr as D,
  cr as E,
  Gt as F,
  Va as G,
  we as I,
  Hu as L,
  Dt as M,
  zu as P,
  Uu as S,
  Zu as T,
  $t as a,
  jt as b,
  $u as c,
  Rn as d,
  Gu as e,
  un as f,
  Vu as g,
  Wu as h,
  $e as i,
  Pe as j,
  qu as k,
  kc as l,
  Ku as m,
  Kc as n,
  Xu as o,
  or as p,
  Yu as q,
  cu as r,
  ed as s,
  mu as t,
  Qu as u,
  Dc as v,
  Ju as w,
  Tu as x,
  St as y,
  yu as z
};
